import React, { useEffect, useState, useRef } from "react";
import "../css/ChatBot.css"
import ChatComponent from "./ChatComponent";
import { isIvrCalendarDateSelectable } from "./ChatCalendarPicker";
import { fetchOptionsOfInput, fetchFeedbackOptions, sendOTPFunction, validateOTPFunction, recordOtpFailure, sendAlternateMobileOtp, validateAlternateMobileOtp, fetchIntentOfInput, fetchIntentsFromStorage, hydrateForwardNdrShipmentContext, getFutureDeliveryDates, createStatusTicket, createComplintTicket, createUpdateTicket, validateShippingID, getShipmentTypeFromInput, getTicketDetails, validateAddressPincode, submitAddressUpdate, parseUserDateToIso, getWhereIsMyShipmentMessage, createRiderConcernTicket, fetchRecordsResponse, fetchIvrCallLogOptions, IVR_CALL_LOG_DISAGREE_FLOWS, IVR_CALL_LOG_CALENDAR_OPEN_BUTTON } from "../js/OptionsHandler";
import { getIntentName, getButtonName, getIntentTicket, getCurrentFlow, getNumber, clearSessionStorage, getAWBValue, setAWBValue, setIntentValue, getIsOTPValidated, clearSelectedKeys, getIsOtpSent, getShipmentStatus, setButtonName, getAttemptCount, getLatestShipmentStatus, setLatestShipmentStatus, getPddBreach, getEDD, getAltNumRetry, setAltNumRetry, resetAltNumRetry, setCurrentFlow, getSessionId, setIntentName, setIntentTicket, getAddressUpdateStep, setAddressUpdateStep, setAddressPincode, getNdrShipmentSnapshot, getNprShipmentSnapshot, setNdrConcernsActive, setNprConcernsActive, isPncReschedulePending, setPncReschedulePending, setAdiPostAddressPending, isAdiPostAddressPending, setRiderConcernsActive, isRiderConcernsActive, setRiderConcernOptions, getRiderConcernOptions, getAltMobileOtpStep, setAltMobileOtpStep, getAltMobilePendingNumber, setAltMobilePendingNumber, clearAltMobileOtpState, setDeliveredClosingFlow, isDeliveredClosingFlow,setIsOtpSent } from "./SessionStorage";
import { NDR_CWFD_AGREEMENT, NDR_CWFD_CALL_LOG, NDR_CWFD_REATTEMPT, NDR_CWFD_REATTEMPT_DELAY, NDR_CWFD_MAX_ATTEMPTS, NDR_CWFD_FLOW_END, buildCwfdCallLogOptions, configureNdrAgreementYesTicket, configureRpcancelPickupAgreementYesTicket, configureRpcancelPickupDisagreeTicket, configureDeliveredAgreementYesTicket, configureDeliveredIncorrectShipmentTicket, configureNprHandedDisagreeTicket, CWFD_AGREE_THANKS, NDR_CRA_AGREEMENT, NDR_CRA_CALL_LOG, NDR_CRA_REATTEMPT, NDR_CRA_REATTEMPT_DELAY, NDR_CRA_MAX_ATTEMPTS, NDR_CRA_FLOW_END, buildCraCallLogOptions, NDR_ADI_AGREEMENT, NDR_ADI_CALL_LOG, NDR_ADI_REATTEMPT, NDR_ADI_REATTEMPT_DELAY, NDR_ADI_FLOW_END, buildAdiCallLogOptions, continueAdiFlowAfterAddressUpdate, NPR_ADI_ADDRESS_UPDATED_MSG, NPR_ADI_AGREE_THANKS, isAddressIncompleteNpr, NPR_ADI_AGREEMENT, NPR_ADI_CALL_LOG, NPR_ADI_REATTEMPT, NPR_ADI_FLOW_END, buildNprAdiCallLogOptions, configureNprAdiDisagreeTicket, NDR_PNC_RESCHEDULE, NDR_PNC_DATE_SELECTION, NDR_PNC_REATTEMPT, NDR_PNC_REATTEMPT_DELAY, NDR_PNC_MAX_ATTEMPTS, NDR_PNC_FLOW_END, PNC_SELECT_DATE_PROMPT, PNC_NO_CHANGES_MSG, RPCANCEL_REFUND_RESCHEDULE, RPCANCEL_REFUND_DATE_SELECTION, RPCANCEL_REFUND_REATTEMPT, RPCANCEL_REFUND_MAX_ATTEMPTS, RPCANCEL_REFUND_FLOW_END, RPCANCEL_REFUND_NO_CHANGES_MSG, RPCANCEL_PICKUP_AGREEMENT, RPCANCEL_PICKUP_CALL_LOG, RPCANCEL_PICKUP_REATTEMPT, RPCANCEL_PICKUP_MAX_ATTEMPTS, RPCANCEL_PICKUP_FLOW_END, NPR_CWFP_AGREEMENT, NPR_CWFP_CALL_LOG, NPR_CWFP_REATTEMPT, NPR_CWFP_FLOW_END, buildHandedCallLogOptions, buildCancelledPickupCallLogOptions, fetchRefundPickupDateOptions, NPR_HANDED_AGREEMENT, NPR_HANDED_CALL_LOG, NPR_HANDED_NOT_VALIDATED, NPR_HANDED_FLOW_END, STILL_HAVE_QUERY, fetchStillHaveQueryOptions, handleNdrEnquiryButtonClick, isNdrEnquirySessionFlow, isNdrShipmentConcernsButton, isNdrSpecialFlowTrigger, isForwardDeliveredContext, isDeliveredShipmentConcernsButton, isDeliveredNotReceivedButton, isDeliveredIncorrectShipmentButton, isDeliveredNotReceivedAgreementContext, fetchDeliveredShipmentConcernsMenuOptions, fetchNdrShipmentConcernsMenuOptions, fetchNprShipmentConcernsMenuOptions, isReverseNprUserContext, isNprShipmentRelatedConcernButton, isReschedulePickupButton, isReversePickupHubContext, isRpcancelShipment, isHandedToOtherCourierReason, isUpdateContactDetailsButton, fetchUpdateContactDetailsMenuOptions, prepareNdrContactDetailsChildFlow, prepareNdrShipmentConcernsChildFlow, isNdrCancelShipmentButton, isNdrRescheduleShipmentButton, isNdrSelfCollectShipmentButton, resolveCancelShipmentMongoType, resolveRescheduleShipmentMongoType, resolveSelfCollectShipmentMongoType, isRenamedShipmentConcernsButton, resolveShipmentConcernsMongoType, fetchCancelShipmentConfirmationOptions, isForwardNdrUserContext, applyOtpShipmentSnapshot, routeForwardNdrSpecialFlows, routeReverseNprSpecialFlows, routeRpcancelSpecialFlows, isNprSpecialFlowLatestStatus, DELIVERED_NOT_RECEIVED, DELIVERED_INCORRECT_SHIPMENT_FLOW,DELIVERED_FLOW_END } from "../js/EnquiryHandler";


import { isFreeTextInputExpected } from "../js/InputGate";
import { saveConversation, createShowStatusButtonsPayload, fetchHeaders, createTicketPayload, createSelectShippingIdPayload } from "../js/payloads";
import { dataReceived } from "../js/EnquiryHandler";
import { config } from "../js/config/config";
import {
  startSessionAnalytics,
  pingSessionAnalytics,
  endSessionAnalytics,
  beaconEndSessionAnalytics,
} from "../js/sessionAnalytics";
import bconImage from "../assets/images/bcon.jpg";
import notifArrow from "../assets/images/small_curved.png";
const { constants } = require('../js/config/constants');

// config values 
// #enhancements_pxb5559 changes done according workflow enhancements
const additionalOptions = constants.prompt_of_additional_options;
const complaintConfirmation = constants.prompt_of_complaint_confirmation;
const requestButtons = constants.request_buttons;
const complaintButtons = constants.complaint_buttons;
const otpKey = constants.prompt_of_otp;
const promptOfNumber = constants.prompt_of_number;
const invalidNoPrompt = constants.prompt_of_invalid_number;
const clearSessionKeys = constants.session_keys;
// #features_pxb5559 changes done for future pickup and auto sent OTP
const statusButtons = constants.status_buttons;
const additionalButtons = constants.additionalButtons;
const FUTURE_DATE_DELIVERY = constants.FUTURE_DATE_DELIVERY;
const RESCHEDULE_SHIPMENT = constants.RESCHEDULE_SHIPMENT;
const RESCHEDULE_PICKUP = constants.RESCHEDULE_PICKUP;
const SELF_COLLECT = constants.SELF_COLLECT;
const SELF_COLLECT_SHIPMENT = constants.SELF_COLLECT_SHIPMENT;
const FUTURE_PICKUP_DATE = constants.FUTURE_PICKUP_DATE;
const UPDATE_ALTERNATE_CONTACT = constants.UPDATE_ALTERNATE_CONTACT;
const UPDATE_ALT_CONTACT_LEGACY = constants.UPDATE_ALT_CONTACT_LEGACY;
const UPDATE_ALT_MOBILE_PICKUP = constants.UPDATE_ALT_MOBILE_PICKUP;
const UPDATE_CONTACT_ADDRESS = constants.UPDATE_CONTACT_ADDRESS;
const CHANGE_ADDRESS_CONFIRMATION = constants.CHANGE_ADDRESS_CONFIRMATION;
const SHIPMENT_NOT_RECEIVED = constants.SHIPMENT_NOT_RECEIVED;
const PRODUCT_NOT_PICKED = constants.PRODUCT_NOT_PICKED;
const CUSTOMER_CARE_CONNECT_PROMPT = constants.CUSTOMER_CARE_CONNECT_PROMPT;
const CANCEL_ORDER = constants.CANCEL_ORDER;
const WHERE_IS_MY_SHIPMENT = constants.WHERE_IS_MY_SHIPMENT;
const RIDER_CONCERN_FLOW = constants.RIDER_CONCERN_FLOW;
const RIDER_CONCERNS_MENU = constants.RIDER_CONCERNS_MENU;
const RIDER_INCIDENT_DATE_PROMPT = constants.RIDER_INCIDENT_DATE_PROMPT;
const RIDER_CONCERN_DESCRIBE_PLACEHOLDER = constants.RIDER_CONCERN_DESCRIBE_PLACEHOLDER;
const quickResponsePrompt = constants.prompt_of_quick_response;
const validInputPrompt = constants.prompt_of_valid_input;
const welcomeMessage = constants.prompt_of_welcome;
const ALT_MOBILE_INCORRECT_MESSAGE = constants.ALT_MOBILE_INCORRECT_MESSAGE;
const ALT_MOBILE_OTP_SENT_MESSAGE = constants.ALT_MOBILE_OTP_SENT_MESSAGE;
const ALT_MOBILE_OTP_INCORRECT_MESSAGE = constants.ALT_MOBILE_OTP_INCORRECT_MESSAGE;
const ALT_MOBILE_OTP_PROMPT = constants.ALT_MOBILE_OTP_PROMPT;
const ALT_MOBILE_OTP_LOCKED_MESSAGE = constants.ALT_MOBILE_OTP_LOCKED_MESSAGE;
const LOGIN_OTP_LOCKED_MESSAGE = constants.LOGIN_OTP_LOCKED_MESSAGE;
const ALT_MOBILE_OTP_MAX_ATTEMPTS = 4;
const NPR_PICKUP_DATE_SELECTION = constants.NPR_PICKUP_DATE_SELECTION;
const NPR_PICKUP_WHERE_IS_LABEL = constants.NPR_PICKUP_WHERE_IS_LABEL;
const NPR_SHIPMENT_CONCERNS_MONGO_TYPE = constants.NPR_SHIPMENT_CONCERNS_MONGO_TYPE;
const NPR_BACKEND_RTO_AGREE_LABELS = ['Yes, I agree', 'Agree'];
const NPR_BACKEND_RTO_DISAGREE_LABELS = ['Disagree', 'No, I disagree'];

const XBeeMark = ({ className = "" }) => (
  <span className={`xbee-mark ${className}`.trim()} aria-hidden="true">
    <span className="xbee-mark-star xbee-mark-star-main">+</span>
    <span className="xbee-mark-star xbee-mark-star-left">+</span>
    <span className="xbee-mark-star xbee-mark-star-right">+</span>
    <span className="xbee-mark-dot xbee-mark-dot-1" />
    <span className="xbee-mark-dot xbee-mark-dot-2" />
    <span className="xbee-mark-dot xbee-mark-dot-3" />
    <span className="xbee-mark-dot xbee-mark-dot-4" />
    <span className="xbee-mark-dot xbee-mark-dot-5" />
  </span>
);

const Chatbot = () => {
  const [isClosed, setIsClosed] = useState(false);
  const [showInput, setShowInput] = useState(true);
  const [userInput, setUserInput] = useState('');
  const [showBot, setShowBot] = useState(false);

  const [selectedMessages, setSelectedMessages] = useState([]);
  const [placeholder, setPlaceholder] = useState(validInputPrompt);
  const [homeIcon, setHomeIcon] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [allowFreeTextInput, setAllowFreeTextInput] = useState(false);
  const [awaitingFeedback, setAwaitingFeedback] = useState(false);
  const feedbackHandled = useRef(false);
  const calendarSelectingRef = useRef(false);
  const [awaitingCancelConfirm, setAwaitingCancelConfirm] = useState(false);
  // True while the last bot message was a button / date menu, i.e. the customer
  // is expected to pick an option instead of typing.
  const [botAwaitingSelection, setBotAwaitingSelection] = useState(false);
  const [headerScrollBlurActive, setHeaderScrollBlurActive] = useState(false);
  const [homeButtonDisabled, setHomeButtonDisabled] = useState(false);
  const isMounted = useRef(false);
  const altMobileOtpRedirectTimerRef = useRef(null);
  const homeClickInFlightRef = useRef(false);
  const lastHomeClickAtRef = useRef(0);
  const homeDisableTimerRef = useRef(null);

  const isAddressUpdateFlow = () => getCurrentFlow() === UPDATE_CONTACT_ADDRESS;

  // Mongo stores these labels without the trailing punctuation the constants
  // carry ("Yes please" vs "Yes please."), so compare them leniently.
  const normalizeAdditionalOption = (value) => (
    String(value || '').trim().toLowerCase().replace(/[.!?]+$/, '')
  );

  const isAssistYesButton = (input) => (
    normalizeAdditionalOption(input) === normalizeAdditionalOption(additionalButtons[0])
  );

  const isAssistNoButton = (input) => (
    normalizeAdditionalOption(input) === normalizeAdditionalOption(additionalButtons[1])
  );

  const normalizeStillHaveQueryChoice = (value) => (
    String(value || '').trim().toLowerCase().replace(/\s+/g, '')
  );

  const isStillHaveQueryNoChoice = (value) => {
    const normalized = normalizeStillHaveQueryChoice(value);
    return normalized === 'no,thanks' || normalized === 'no,thanks.';
  };

  const isStillHaveQueryYesChoice = (value) => {
    const normalized = normalizeStillHaveQueryChoice(value);
    return normalized === 'yes,ihave' || normalized === 'yes,ihave.';
  };

  const normalizePickupLatestStatus = (status) => (
    String(status || '').trim().toLowerCase().replace(/\s+/g, '_')
  );

  const isPendingPickupContext = () => {
    const latestStatus = normalizePickupLatestStatus(
      shipmentPddData.current.latestStatus || getLatestShipmentStatus()
    );
    return latestStatus === 'pending_for_pickup' || latestStatus === 'npr_pickup_not_done';
  };

  const isPickupDoneContext = () => {
    const latestStatus = normalizePickupLatestStatus(
      shipmentPddData.current.latestStatus || getLatestShipmentStatus()
    );
    return latestStatus === 'pickupdone' || latestStatus === 'pickup_done' || latestStatus === 'picked';
  };

  const isOfdContext = () => {
    const latestStatus = String(
      shipmentPddData.current.latestStatus || getLatestShipmentStatus() || ''
    ).trim().toLowerCase();
    return latestStatus === 'ofd';
  };

  const isPickupAddressUpdateButton = (message) => (
    message === UPDATE_CONTACT_ADDRESS
    || message === 'Change the address'
  );

  const isPickupAltMobileButton = (message) => (
    message === UPDATE_ALT_MOBILE_PICKUP
    || message === UPDATE_ALTERNATE_CONTACT
    || message === 'I want to update alternate contact number'
  );

  const isNprPickupBackendContext = () => isReversePickupHubContext();

  const delegateNprPickupFetchRecords = async (input, { followWithStillHaveQuery = false } = {}) => {
    const label = String(input || '').trim();
    if (!label) {
      return;
    }
    setButtonName(label);
    const response = await fetchRecordsWithThinking(label);
    await insertMessages(response);
    if (followWithStillHaveQuery) {
      await promptStillHaveQuery();
    }
  };

  const isNprBackendCallLogLabel = (message) => (
    /^\d{2}-\d{2}-\d{4}\s*\|\s*\d{2}:\d{2}(?::\d{2})?$/i.test(String(message || '').trim())
  );

  const startPickupAddressUpdateFlow = async (message) => {
    setButtonName(message);
    setIntentName('update-contact-address');
    setIntentTicket('update-contact-address-yes');
    setCurrentFlow(UPDATE_CONTACT_ADDRESS);
    setAddressUpdateStep('pincode');
    setAllowFreeTextInput(true);
    await insertMessages('Please enter the 6-digit pincode to check serviceability.');
    handlePlaceholderChange('Please enter the 6-digit pincode to check serviceability.');
  };

  const startPickupAltMobileFlow = async (message) => {
    setButtonName(message);
    setIntentName('update-contact-number');
    setIntentTicket('update-contact-number-yes');
    setCurrentFlow(UPDATE_ALTERNATE_CONTACT);
    clearAltMobileOtpState();
    resetAltNumRetry();
    // Drop any stale address-update state so the next typed input is
    // validated as a mobile number, not a pincode.
    setAddressUpdateStep('');
    setAllowFreeTextInput(true);
    await insertMessages('Please enter the new alternate mobile number.');
    handlePlaceholderChange('Please enter the new alternate mobile number.');
  };

  const isNdrCwfdFlow = () => {
    const flow = getCurrentFlow();
    return Boolean(flow && flow.startsWith('NDR CWFD'));
  };

  const isNdrCraFlow = () => {
    const flow = getCurrentFlow();
    return Boolean(flow && flow.startsWith('NDR CRA'));
  };

  const isNdrAdiFlow = () => {
    const flow = getCurrentFlow();
    return Boolean(flow && flow.startsWith('NDR ADI'));
  };

  const isNprAdiFlow = () => {
    const flow = getCurrentFlow();
    return Boolean(flow && flow.startsWith('NPR ADI'));
  };

  const isRpcancelPickupFlow = () => {
    const flow = getCurrentFlow();
    return Boolean(flow && flow.startsWith('RPCancel pickup'));
  };

  const isNprHandedFlow = () => {
    const flow = getCurrentFlow();
    return flow === NPR_HANDED_AGREEMENT
      || flow === NPR_HANDED_CALL_LOG
      || flow === NPR_HANDED_FLOW_END;
  };

  const isNprCwfpFlow = () => {
    const flow = getCurrentFlow();
    return flow === NPR_CWFP_AGREEMENT
      || flow === NPR_CWFP_CALL_LOG
      || flow === NPR_CWFP_REATTEMPT
      || flow === NPR_CWFP_FLOW_END;
  };

  const isCustomerCareConnectPromptFlow = (flow = getCurrentFlow()) => (
    flow === CUSTOMER_CARE_CONNECT_PROMPT
    || flow === 'Do you want to connect with the customer care team?'
    || flow === 'Yes,I have'
  );

  const isNprHandedSessionFlow = (flow = getCurrentFlow()) => (
    flow === NPR_HANDED_NOT_VALIDATED
    || flow === NPR_HANDED_AGREEMENT
    || flow === NPR_HANDED_CALL_LOG
    || flow === NPR_HANDED_FLOW_END
    || flow === RPCANCEL_PICKUP_AGREEMENT
    || flow === RPCANCEL_PICKUP_CALL_LOG
    || flow === RPCANCEL_PICKUP_FLOW_END
    || flow === STILL_HAVE_QUERY
    || flow === CUSTOMER_CARE_CONNECT_PROMPT
    || flow === 'Do you want to connect with the customer care team?'
  );

  const isNdrAuthenticFlow = () => {
    const flow = getCurrentFlow();
    if (flow === NPR_HANDED_CALL_LOG || flow === NPR_HANDED_FLOW_END) {
      return true;
    }
    // Validated agree/disagree flows must wait for YES/NO (and IVR call logs)
    // before any order-status ticket or session clear.
    return isNdrCwfdFlow()
      || isNdrCraFlow()
      || isNdrAdiFlow()
      || isNprAdiFlow()
      || isNprCwfpFlow()
      || isNprHandedFlow()
      || isRpcancelPickupFlow();
  };

  const isNprHandedPostTicketFlow = (flow = getCurrentFlow()) => isNprHandedSessionFlow(flow);

  const promptStillHaveQuery = async () => {
    setCurrentFlow(STILL_HAVE_QUERY);
    const options = await fetchStillHaveQueryOptions();
    await insertMessages(options);
  };

  // Delivered-only closing sequence: still-have-query → CC connect → additional options
  const promptDeliveredStillHaveQuery = async () => {
    setDeliveredClosingFlow(true);
    await promptStillHaveQuery();
  };

  const finishDeliveredClosingToAdditionalOptions = async () => {
    setDeliveredClosingFlow(false);
    await fetchResponses(additionalOptions, false);
  };

  const shouldPromptAdditionalOptionsAfterStatus = () => !isAddressUpdateFlow() && !isNdrAuthenticFlow();

  const isOrderStatusClosedTicketFlow = (flow = getCurrentFlow()) => (
    flow === NDR_CWFD_REATTEMPT
    || flow === NDR_CWFD_MAX_ATTEMPTS
    || flow === NDR_CRA_REATTEMPT
    || flow === NDR_CRA_MAX_ATTEMPTS
    || flow === NDR_ADI_REATTEMPT
    || flow === NDR_PNC_REATTEMPT
    || flow === NDR_PNC_MAX_ATTEMPTS
    || flow === RPCANCEL_REFUND_MAX_ATTEMPTS
    || flow === RPCANCEL_REFUND_REATTEMPT
    || flow === RPCANCEL_PICKUP_MAX_ATTEMPTS
    || flow === RPCANCEL_PICKUP_REATTEMPT
    || flow === NPR_CWFP_REATTEMPT
    || flow === NPR_HANDED_NOT_VALIDATED
  );

  const isNdrReattemptComplaintFlow = (flow = getCurrentFlow()) => (
    flow === NDR_PNC_REATTEMPT_DELAY
    || flow === NDR_CWFD_REATTEMPT_DELAY
    || flow === NDR_CRA_REATTEMPT_DELAY
    || flow === NDR_ADI_REATTEMPT_DELAY
  );

  const isRefundReplacementNoAutoTicketFlow = (flow = getCurrentFlow()) => (
    flow === RPCANCEL_REFUND_RESCHEDULE
    || flow === RPCANCEL_REFUND_DATE_SELECTION
    || flow === RPCANCEL_REFUND_FLOW_END
    || flow === NDR_PNC_RESCHEDULE
    || flow === NDR_PNC_DATE_SELECTION
  );

  const flattenChatText = (response) => (
    Array.isArray(response)
      ? response.map((item) => item?.content || item?.text || '').join(' ')
      : String(response || '')
  );

  const submitAddressPincode = async (pincode) => {
    const trimmedPincode = (pincode || '').trim();
    if (!/^\d{6}$/.test(trimmedPincode)) {
      setAddressUpdateStep('pincode');
      setAllowFreeTextInput(true);
      await insertMessages('Please enter a valid 6-digit pincode.');
      setUserInput('');
      handlePlaceholderChange('Please enter the 6-digit pincode to check serviceability.');
      return;
    }
    const response = await withThinkingIndicator(() => validateAddressPincode(trimmedPincode));
    if (Array.isArray(response) && response.length === 0) {
      insertMessages('Sorry, we could not validate the pincode right now. Please try again.');
      setUserInput('');
      return;
    }
    const message = flattenChatText(response);
    if (message.toLowerCase().includes('please enter your address')) {
      setAddressPincode(trimmedPincode);
      sessionStorage.setItem('update_address_pincode', trimmedPincode);
      setAddressUpdateStep('address');
      setAllowFreeTextInput(true);
      handlePlaceholderChange('Please enter your full address.');
      insertMessages(response);
      setUserInput('');
      return;
    }
    // Not serviceable: keep API copy (apology + assist). Do not replace with a
    // different validation sentence or allow another pincode attempt.
    insertMessages(response);
    setAllowFreeTextInput(false);
    setAddressUpdateStep('');
    setAddressPincode('');
    sessionStorage.removeItem('update_address_pincode');
    setCurrentFlow('');
    if (getButtonName() === UPDATE_CONTACT_ADDRESS || getButtonName() === `${UPDATE_CONTACT_ADDRESS} - YES`) {
      setButtonName('');
    }
    if (getIntentName() === 'update-contact-address') {
      setIntentName('');
    }
    setAdiPostAddressPending(false);
    setUserInput('');
    handlePlaceholderChange(quickResponsePrompt);
    fetchResponses(additionalOptions, false);
  };

  // Stage Mongo / NPR may use singular "concern" vs plural "concerns".
  const isRiderConcernsMenuButton = (message) => {
    const normalized = String(message || '').trim().toLowerCase().replace(/\.$/, '');
    return (
      normalized === 'i have rider related concerns'
      || normalized === 'i have rider related concern'
      || normalized.includes('rider related concern')
    );
  };

  // Sub-concern buttons are whatever Mongo returned for the rider menu — never hardcoded.
  const isRiderConcernButton = (message) => (
    isRiderConcernsActive() && getRiderConcernOptions().includes(String(message || '').trim())
  );

  const openRiderConcernsMenu = async (message) => {
    // Prefer canonical plural Mongo type; fall back to singular if stage uses that key.
    setButtonName(RIDER_CONCERNS_MENU);
    const menu = await withThinkingIndicator(async () => {
      let result = await fetchRecordsResponse(RIDER_CONCERNS_MENU);
      if (!result || result.length === 0) {
        result = await fetchRecordsResponse('I have rider related concern');
      }
      return result;
    });
    const labels = [];
    (Array.isArray(menu) ? menu : []).forEach((item) => {
      if (item && Array.isArray(item.buttons)) {
        item.buttons.forEach((btn) => btn && btn.content && labels.push(btn.content));
      } else if (item?.type === 'button' && item?.content) {
        labels.push(item.content);
      }
    });
    setRiderConcernsActive(true);
    setRiderConcernOptions(labels);
    if (menu && menu.length > 0) {
      await insertMessages(menu);
    } else {
      insertMessages('Sorry, we could not load rider concern options right now. Please try again.');
    }
    setHomeIcon(true);
  };

  const startRiderConcernFlow = async (message) => {
    setCurrentFlow(RIDER_CONCERN_FLOW);
    setButtonName(message);
    sessionStorage.setItem('rider_concern_type', message);
    sessionStorage.setItem('rider_concern_step', 'describe');
    sessionStorage.removeItem('rider_concern_description');
    // Show the sympathy + "describe the incident" prompt from Mongo for this concern.
    const prompt = await withThinkingIndicator(async () => {
      const result = await fetchRecordsResponse(message);
      return result;
    });
    if (Array.isArray(prompt) && prompt.length > 0) {
      await insertMessages(prompt);
    } else {
      insertMessages('So sorry to hear that! could you please describe the incident?');
    }
    setAllowFreeTextInput(true);
    handlePlaceholderChange(RIDER_CONCERN_DESCRIBE_PLACEHOLDER);
    setHomeIcon(true);
  };

  const isIvrCallLogLabel = (value) => {
    const trimmed = String(value || '').trim();
    return (
      /^\d{2}-\d{2}-\d{4}(\s*\|\s*\d{2}:\d{2}(?::\d{2})?)?$/.test(trimmed)
      || /^(OTP|CALL|IVR)\s*-/i.test(trimmed)
    );
  };

  // IVR buttons are "DD-MM-YYYY | HH:MM:SS"; ticket stores "YYYY-MM-DD HH:MM:SS" when time is present.
  const parseRiderIncidentWhen = (value) => {
    const trimmed = String(value || '').trim();
    const callLogMatch = trimmed.match(/^(\d{2}-\d{2}-\d{4})\s*\|\s*(\d{2}:\d{2}(?::\d{2})?)$/);
    if (callLogMatch) {
      const isoDate = parseUserDateToIso(callLogMatch[1]);
      return isoDate ? `${isoDate} ${callLogMatch[2]}` : null;
    }
    const plainDateMatch = trimmed.match(/^(\d{2}-\d{2}-\d{4})$/);
    if (plainDateMatch) {
      return parseUserDateToIso(plainDateMatch[1]);
    }
    const legacyMatch = trimmed.match(/^(?:OTP|CALL|IVR)\s*-\s*(.+)$/i);
    if (legacyMatch) {
      const afterDash = String(legacyMatch[1] || '').trim();
      const isoDate = parseUserDateToIso(afterDash.split(/\s+/)[0]);
      if (isoDate) {
        const timePart = afterDash.includes(' ') ? afterDash.split(/\s+/).slice(1).join(' ') : '';
        return timePart ? `${isoDate} ${timePart}` : isoDate;
      }
    }
    return null;
  };

  const askRiderIncidentDate = async () => {
    setCurrentFlow(RIDER_CONCERN_FLOW);
    sessionStorage.setItem('rider_concern_step', 'date');
    sessionStorage.removeItem('ivr_calendar_date_selected');
    setAllowFreeTextInput(false);
    setUserInput('');
    handlePlaceholderChange('Please select a date below.');
    try {
      const pickerOptions = await withThinkingIndicator(() => fetchIvrCallLogOptions(getAWBValue()));
      if (Array.isArray(pickerOptions) && pickerOptions.length > 0) {
        await insertMessages(pickerOptions);
        return;
      }
      const serverMessage = Array.isArray(pickerOptions)
        ? [...pickerOptions].reverse().find((option) => option?.type === 'text' && option?.content)?.content
        : '';
      const errorMessage = typeof pickerOptions === 'string'
        ? pickerOptions
        : serverMessage || 'Unable to show the date picker right now. Please try again.';
      await insertMessages(errorMessage);
    } catch (error) {
      console.error('[askRiderIncidentDate] IVR call-log fetch failed:', error);
      await insertMessages('Unable to fetch IVR call attempts right now. Please try again.');
    }

    sessionStorage.removeItem('rider_concern_type');
    sessionStorage.removeItem('rider_concern_step');
    sessionStorage.removeItem('rider_concern_description');
    setRiderConcernsActive(false);
    handlePlaceholderChange('');
    await promptStillHaveQuery();
  };

  const completeRiderConcern = async (isoDate) => {
    const concernType = sessionStorage.getItem('rider_concern_type') || '';
    const description = sessionStorage.getItem('rider_concern_description') || '';
    const confirmation = await withThinkingIndicator(
      () => createRiderConcernTicket(concernType, description, isoDate)
    );
    await insertMessages(confirmation);
    // Clear rider-concern session state so subsequent input isn't treated as free text.
    sessionStorage.removeItem('rider_concern_type');
    sessionStorage.removeItem('rider_concern_step');
    sessionStorage.removeItem('rider_concern_description');
    sessionStorage.removeItem('ivr_calendar_date_selected');
    setRiderConcernsActive(false);
    setAllowFreeTextInput(false);
    handlePlaceholderChange('');
    setUserInput('');
    await promptStillHaveQuery();
  };

  const handleRiderConcernInput = async (input) => {
    const step = sessionStorage.getItem('rider_concern_step');
    if (step === 'describe') {
      sessionStorage.setItem('rider_concern_description', input);
      setUserInput('');
      await askRiderIncidentDate();
      return;
    }
  };

  const createAdiFollowUpTicketSilently = async () => {
    // Address ticket already succeeded and was shown. Follow-up enquiry/complaint
    // tickets must not surface "open ticket already exists" or additional-options.
    const awb = getAWBValue();
    if (!awb) {
      return;
    }
    const flow = getCurrentFlow();
    try {
      if (isNdrReattemptComplaintFlow(flow)) {
        await withThinkingIndicator(() => createComplintTicket(awb, getIntentTicket()));
        return;
      }
      if (isOrderStatusClosedTicketFlow(flow) || String(getIntentName() || '').includes('order-status')) {
        await withThinkingIndicator(() => createStatusTicket(awb, getIntentTicket() || 'order-status-ticket'));
      }
    } catch (error) {
      console.log('[createAdiFollowUpTicketSilently] follow-up ticket failed:', error);
    }
  };

  const handleAddressUpdateAfterTicket = async (response) => {
    if (/created a ticket|address has (?:already )?been updated/i.test(String(response))) {
      // Address incomplete (add1) → after ticket / already-updated, run NDR/NPR-ADI Validated check (add2)
      const adiNext = await continueAdiFlowAfterAddressUpdate();
      if (adiNext) {
        await insertMessages(adiNext.messages);
        if (adiNext.type === 'agreement') {
          // Validated: move to Yes/No — do not create another ticket yet.
          return;
        }
        if (adiNext.type === 'reattempt') {
          await createAdiFollowUpTicketSilently();
          return;
        }
        if (adiNext.type === 'complaint') {
          // NPR ADI not validated (Excel row 12): FakeNDR 133 — create silently, keep pickup message
          try {
            await withThinkingIndicator(() => createComplintTicket(getAWBValue(), getIntentTicket()));
          } catch (error) {
            console.log('[handleAddressUpdateAfterTicket] NPR ADI complaint failed:', error);
          }
          setCurrentFlow(NPR_ADI_FLOW_END);
        }
        return;
      }
      // Regular "I want to change the address" — keep AWB/NDR session for "Yes please"
      setAdiPostAddressPending(false);
      fetchResponses(additionalOptions, false);
      return;
    }
    setAdiPostAddressPending(false);
  };

  // Create the address-update ticket and continue any post-ticket flow.
  // Shared by the confirmation "Yes" path and the direct (no-confirmation) path.
  const finalizeAddressUpdate = async () => {
    const address = sessionStorage.getItem('update_address_text') || '';
    if (!address) {
      insertMessages('Sorry, we could not update your address because the address is missing. Please try again.');
      setAddressUpdateStep('');
      return;
    }
    const response = await withThinkingIndicator(() => submitAddressUpdate(address));
    if (!response || (Array.isArray(response) && response.length === 0)) {
      insertMessages('Sorry, we could not update your address right now. Please try again.');
      return;
    }
    const isNewNprAdiTicket = (
      isAdiPostAddressPending()
      && isAddressIncompleteNpr(getNprShipmentSnapshot())
      && !/already been updated/i.test(String(response))
    );
    const displayResponse = isNewNprAdiTicket ? NPR_ADI_ADDRESS_UPDATED_MSG : response;
    insertMessages(displayResponse);
    setAddressUpdateStep('');
    sessionStorage.removeItem('update_address_pincode');
    sessionStorage.removeItem('update_address_text');
    await handleAddressUpdateAfterTicket(displayResponse);
  };

  const submitAddressText = async (address) => {
    const trimmedAddress = (address || '').trim();
    if (!trimmedAddress || trimmedAddress.length < 10) {
      insertMessages('Please enter a valid address with at least 10 characters.');
      setUserInput('');
      return;
    }

    sessionStorage.setItem('update_address_text', trimmedAddress);
    setCurrentFlow(UPDATE_CONTACT_ADDRESS);
    setUserInput('');

    // "Address incomplete" (Direct ADI) shipments must not see the
    // "Are you sure…?" confirmation — the customer is fixing the address the
    // rider couldn't find, so update it straight away.
    if (isAdiPostAddressPending()) {
      setAddressUpdateStep('');
      setAllowFreeTextInput(false);
      handlePlaceholderChange('');
      await finalizeAddressUpdate();
      return;
    }

    // Regular "I want to change the address": confirm before creating the ticket.
    setAddressUpdateStep('confirm');
    setAllowFreeTextInput(false);
    handlePlaceholderChange('Click on the appropriate Quick Response button.');

    // MongoDB collection type: "Change address confirmation"
    const confirmation = await fetchRecordsWithThinking(CHANGE_ADDRESS_CONFIRMATION);
    if (!confirmation || (Array.isArray(confirmation) && confirmation.length === 0)) {
      insertMessages('Sorry, we could not load the address confirmation options. Please try again.');
      setAddressUpdateStep('address');
      setAllowFreeTextInput(true);
      handlePlaceholderChange('Please enter your full address.');
      return;
    }
    insertMessages(confirmation);
  };
  // accumulates all messages for the session; flushed to DB on chat end
  const conversationLog = useRef([]);
  const sessionMeta = useRef({ shippingIds: [], mobile_number: '' });
  // stores PDD data in memory so it survives clearSelectedKeys
  const shipmentPddData = useRef({ pddBreach: null, pdd: '', latestStatus: '', awb: '' });

  const logMessage = (sender, message) => {
    if (!message || (typeof message !== 'string') || message.trim() === '') return;
    conversationLog.current.push({
      sender,
      message: String(message),
      timestamp: new Date().toISOString(),
    });
    if (sender === 'user' && getIsOTPValidated() === 'true') {
      pingSessionAnalytics({
        shippingId: sessionMeta.current.shippingId || getAWBValue() || '',
      });
    }
  };

  const flushConversation = async () => {
    if (conversationLog.current.length === 0) return;
    const batch = [...conversationLog.current];
    conversationLog.current = [];
    await saveConversation(batch, sessionMeta.current);
  };

  useEffect(() => {
    if (!isMounted.current) {
      sessionStorage.removeItem('accessToken');
      sessionStorage.removeItem('tokenExpiry');
      fetchHomeButtons();
      clearSessionStorage();
      isMounted.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setSelectedMessages]);

  // Tab abandon → mark session non_completed using last activity on server
  useEffect(() => {
    const onPageHide = () => {
      if (getIsOTPValidated() !== 'true') return;
      beaconEndSessionAnalytics({
        endedReason: 'abandoned',
        shippingId: sessionMeta.current.shippingId || getAWBValue() || '',
      });
    };
    window.addEventListener('pagehide', onPageHide);
    window.addEventListener('beforeunload', onPageHide);
    return () => {
      window.removeEventListener('pagehide', onPageHide);
      window.removeEventListener('beforeunload', onPageHide);
    };
  }, []);

  const fetchHomeButtons = async () => {
    try {
      const welcomeMsg = welcomeMessage;
      setSelectedMessages([{ type: 'server', text: welcomeMsg, isType: 'text', timestamp: returnTime() }]);
      logMessage('chatBot', welcomeMsg);
      // The welcome message asks for an AWB / registered mobile number, so the
      // chat reopens with the input box usable.
      setBotAwaitingSelection(false);
    } catch (error) {
      console.error('Error fetching home buttons:', error);
    }
  };
  
  const isEnquirySessionFlow = (flow = getCurrentFlow()) => (
    isNdrEnquirySessionFlow(flow)
  );

  const tryHandleWhereIsMyShipmentSpecialFlow = async () => {
    if (getButtonName() !== WHERE_IS_MY_SHIPMENT) {
      return false;
    }
    let ndrSnapshot = getNdrShipmentSnapshot();
    if (!ndrSnapshot && getAWBValue()) {
      // OTP-success path can render latest-status buttons without hydrating NDR snapshot.
      // Pull shipment details once so NDR reason-based routing can run.
      await fetchIntentOfInput(getAWBValue(), true);
      ndrSnapshot = getNdrShipmentSnapshot();
    }
    const isForwardNdrSnapshot = Boolean(
      ndrSnapshot
      && String(ndrSnapshot.businessType || '').toLowerCase() === 'forward'
      && String(ndrSnapshot.latestStatus || '').toLowerCase() === 'ndr'
    );
    if (isForwardNdrSnapshot) {
      const ndrResponse = await routeForwardNdrSpecialFlows(ndrSnapshot);
      insertMessages(ndrResponse);
      await applyPostOrderStatusFlowEffects(ndrResponse, getAWBValue());
      return true;
    }

    // NPR Address incomplete / handed / CWFP — same forced special-flow path as NDR
    let nprSnapshot = getNprShipmentSnapshot();
    const latestPickupStatus = String(getLatestShipmentStatus() || '').trim().toLowerCase();
    if (
      !nprSnapshot
      && getAWBValue()
      && (isNprSpecialFlowLatestStatus(latestPickupStatus) || latestPickupStatus === 'rpcancel')
    ) {
      await fetchIntentOfInput(getAWBValue(), true);
      nprSnapshot = getNprShipmentSnapshot();
    }
    const isReverseNprSnapshot = Boolean(
      nprSnapshot
      && String(nprSnapshot.businessType || '').toLowerCase() === 'reverse'
      && isNprSpecialFlowLatestStatus(nprSnapshot)
    );
    const isReverseRpcancelSnapshot = Boolean(
      nprSnapshot
      && String(nprSnapshot.businessType || '').toLowerCase() === 'reverse'
      && isRpcancelShipment(nprSnapshot)
    );
    if (!isReverseNprSnapshot && !isReverseRpcancelSnapshot) {
      return false;
    }
    const nprResponse = await routeReverseNprSpecialFlows(nprSnapshot);
    if (!nprResponse) {
      return false;
    }
    insertMessages(nprResponse);
    await applyPostOrderStatusFlowEffects(nprResponse, getAWBValue());
    return true;
  };

  const applyPostOrderStatusFlowEffects = async (response, shippingId) => {
    if (!Array.isArray(response) && String(response).toLowerCase().includes('enter your pincode below')) {
      setAddressUpdateStep('pincode');
    }
    const currentFlow = getCurrentFlow();
    if (isNdrReattemptComplaintFlow(currentFlow)) {
      await createComplaintTicket(shippingId || getAWBValue());
      return;
    }
    if (!getIntentName().includes('order-status') || isEnquirySessionFlow(currentFlow)) {
      return;
    }
    // Multi-shipment list after OTP login is an array of buttons — no AWB selected yet.
    // Do not create an enquiry ticket or clear OTP session keys here.
    const resolvedShippingId = shippingId || getAWBValue();
    if (Array.isArray(response) || !resolvedShippingId) {
      return;
    }
    if (isOrderStatusClosedTicketFlow(currentFlow)) {
      await createTicket(resolvedShippingId);
      return;
    }
    if (!isAddressUpdateFlow() && !isNdrAuthenticFlow() && !isRefundReplacementNoAutoTicketFlow(currentFlow)) {
      await createTicket(resolvedShippingId);
    }
  };

  const handleClose = () => {
    setShowPopup(true);
  };

  const handleConfirmExit = async () => {
    await flushConversation();
    await endSessionAnalytics({
      endedReason: 'user_closed',
      shippingId: sessionMeta.current.shippingId || getAWBValue() || '',
    });
    setShowBot(false);
    fetchHomeButtons();
    setShowPopup(false);
    setAllowFreeTextInput(false);
    clearSessionStorage();
    setAwaitingFeedback(false);
    setAwaitingCancelConfirm(false);
    feedbackHandled.current = false;
    resetAltNumRetry();
    shipmentPddData.current = { pddBreach: null, pdd: '', latestStatus: '', awb: '' };
  }

  const handleCancelExit = () => {
    setShowPopup(false);
    setShowBot(true);
  }

  const handleMinimize = () => {
    setShowBot(false);
  };

  const handleBot = () => {
    setShowBot(true);
    setShowInput(true)
    setIsClosed(false);
  };

  function returnTime() {
    var date = new Date();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime
  }

  const THINKING_MESSAGE_ID = '__thinking_indicator__';
  const thinkingDepthRef = useRef(0);
  const HOME_DISABLE_WHILE_LOADING_MS = 10000;

  const clearHomeDisableTimer = () => {
    if (homeDisableTimerRef.current) {
      clearTimeout(homeDisableTimerRef.current);
      homeDisableTimerRef.current = null;
    }
  };

  const lockHomeWhileLoading = () => {
    setHomeButtonDisabled(true);
    clearHomeDisableTimer();
    homeDisableTimerRef.current = setTimeout(() => {
      homeDisableTimerRef.current = null;
      setHomeButtonDisabled(false);
    }, HOME_DISABLE_WHILE_LOADING_MS);
  };

  const unlockHomeAfterLoading = () => {
    clearHomeDisableTimer();
    setHomeButtonDisabled(false);
  };

  const hideThinkingIndicator = () => {
    thinkingDepthRef.current = Math.max(0, thinkingDepthRef.current - 1);
    if (thinkingDepthRef.current > 0) return;
    setSelectedMessages((prev) => prev.filter((msg) => msg?.id !== THINKING_MESSAGE_ID));
    unlockHomeAfterLoading();
  };

  const showThinkingIndicator = () => {
    thinkingDepthRef.current += 1;
    if (thinkingDepthRef.current > 1) return;
    lockHomeWhileLoading();
    setSelectedMessages((prev) => {
      if (prev.some((msg) => msg?.id === THINKING_MESSAGE_ID)) {
        return prev;
      }
      return [
        ...prev,
        {
          id: THINKING_MESSAGE_ID,
          type: 'server',
          isType: 'thinking',
          text: '',
          timestamp: returnTime(),
        },
      ];
    });
  };

  const withThinkingIndicator = async (work) => {
    showThinkingIndicator();
    try {
      return await work();
    } finally {
      hideThinkingIndicator();
    }
  };

  const fetchRecordsWithThinking = (input) => (
    withThinkingIndicator(() => fetchRecordsResponse(input))
  );

  const extractShipmentId = (text) => {
    try {
      const match = text.match(/Shipment ID\s*:\s*(\S+)/);
      return match ? match[1] : null;
    } catch (error) {
      console.log('error in extractShipmentId', error);
      return null;
    }
  };

  // Only treat typed input as a pincode while the address-update step is
  // explicitly 'pincode'. Stale intent/button names after a failed/closed
  // address flow must not keep routing free-text as pincode validation.
  const isAddressPincodeStep = () => getAddressUpdateStep() === 'pincode';

  const isAddressTextStep = () => getAddressUpdateStep() === 'address';

  // The bot is waiting for an alternate mobile number. Any typed input in this
  // context must be validated as a mobile number — never rerouted to the
  // pincode / OTP / AWB flows based on its digit count. The alternate-number
  // prompt only ever appears after OTP validation; before that the same button
  // name can be set while the bot is still collecting the registered mobile/AWB.
  const isAlternateMobileContext = () => {
    if (getIsOTPValidated() !== 'true') {
      return false;
    }
    if (getAltMobileOtpStep() === 'pending_otp') {
      return false;
    }
    const buttonName = getButtonName();
    return (
      buttonName === `${UPDATE_ALTERNATE_CONTACT} - YES`
      || buttonName === UPDATE_ALTERNATE_CONTACT
      || buttonName === UPDATE_ALT_CONTACT_LEGACY
      || buttonName === UPDATE_ALT_MOBILE_PICKUP
      || getCurrentFlow() === UPDATE_ALTERNATE_CONTACT
      || getIntentName() === 'update-contact-number'
    );
  };

  const isAlternateMobileOtpStep = () => getAltMobileOtpStep() === 'pending_otp';

  const submitAlternateMobileNumber = async (value) => {
    const trimmed = (value || '').trim();
    if (!/^\d{10}$/.test(trimmed)) {
      insertMessages(ALT_MOBILE_INCORRECT_MESSAGE);
      return;
    }
    const otpResult = await withThinkingIndicator(() => sendAlternateMobileOtp(trimmed));
    if (!otpResult?.success) {
      insertMessages(ALT_MOBILE_INCORRECT_MESSAGE);
      return;
    }
    setAltMobilePendingNumber(trimmed);
    setAltMobileOtpStep('pending_otp');
    resetAltNumRetry();
    setAllowFreeTextInput(true);
    insertMessages(ALT_MOBILE_OTP_SENT_MESSAGE);
    handlePlaceholderChange(ALT_MOBILE_OTP_PROMPT);
  };

  const submitAlternateMobileOtpVerification = async (otpValue) => {
    const trimmedOtp = (otpValue || '').trim();
    if (!/^\d{6}$/.test(trimmedOtp)) {
      insertMessages(ALT_MOBILE_OTP_INCORRECT_MESSAGE);
      return;
    }
    const pendingMobile = getAltMobilePendingNumber();
    const verifyResult = await withThinkingIndicator(
      () => validateAlternateMobileOtp(trimmedOtp, pendingMobile)
    );
    if (verifyResult === 'OTP has expired') {
      clearAltMobileOtpState();
      resetAltNumRetry();
      insertMessages(verifyResult);
      setAllowFreeTextInput(true);
      handlePlaceholderChange('Please enter the new alternate mobile number.');
      return;
    }
    if (verifyResult !== 'ALT-MOBILE-OTP-SUCCESS') {
      const failedAttempts = getAltNumRetry() + 1;
      setAltNumRetry(failedAttempts);
      if (
        failedAttempts >= ALT_MOBILE_OTP_MAX_ATTEMPTS
        || String(verifyResult || '').startsWith('Too many failed attempts')
      ) {
        setUserInput('');
        setAllowFreeTextInput(false);
        clearAltMobileOtpState();
        insertMessages(ALT_MOBILE_OTP_LOCKED_MESSAGE);
        if (altMobileOtpRedirectTimerRef.current) {
          clearTimeout(altMobileOtpRedirectTimerRef.current);
        }
        altMobileOtpRedirectTimerRef.current = setTimeout(() => {
          altMobileOtpRedirectTimerRef.current = null;
          resetAltNumRetry();
          handleHomeButtonClick();
        }, 20000);
        return;
      }
      insertMessages(ALT_MOBILE_OTP_INCORRECT_MESSAGE);
      handlePlaceholderChange(ALT_MOBILE_OTP_PROMPT);
      return;
    }
    clearAltMobileOtpState();
    resetAltNumRetry();
    setAllowFreeTextInput(false);
    setIntentName('update-contact-number');
    setIntentTicket('update-contact-number-yes');
    setCurrentFlow(UPDATE_ALTERNATE_CONTACT);
    await createUpdatTicket(pendingMobile);
  };

  const isRiderConcernStep = (step) => (
    getCurrentFlow() === RIDER_CONCERN_FLOW
    && sessionStorage.getItem('rider_concern_step') === step
  );

  const isDateSelectionFlow = () => {
    const flow = getCurrentFlow();
    return (
      flow === NDR_PNC_DATE_SELECTION
      || flow === RPCANCEL_REFUND_DATE_SELECTION
      || flow === NPR_PICKUP_DATE_SELECTION
    );
  };

  // Dates always come from the buttons we render (IVR attempts, reschedule
  // slots, calendar) — a typed date is never accepted.
  const isDateOnlyStep = () => isRiderConcernStep('date') || isDateSelectionFlow();

  const isOtpEntryStep = () => getIsOtpSent() === 'true' && getIsOTPValidated() !== 'true';

  const handleLoginOtpLocked = () => {
    insertMessages(LOGIN_OTP_LOCKED_MESSAGE);
    setUserInput('');
    setAllowFreeTextInput(false);
    setBotAwaitingSelection(true);
    setHomeIcon(false);
    handlePlaceholderChange('');
    if (altMobileOtpRedirectTimerRef.current) {
      clearTimeout(altMobileOtpRedirectTimerRef.current);
    }
    altMobileOtpRedirectTimerRef.current = setTimeout(() => {
      altMobileOtpRedirectTimerRef.current = null;
      clearSessionStorage();
      shipmentPddData.current = { pddBreach: null, pdd: '', latestStatus: '', awb: '' };
      sessionMeta.current = { shippingIds: [], mobile_number: '' };
      setBotAwaitingSelection(false);
      handlePlaceholderChange(validInputPrompt);
      fetchHomeButtons();
    }, 5000);
  };

  // AWB / mobile tabs only on the welcome step — not while quick-response menus are shown.
  const isIdentifierEntryStep = () => (
    getIsOtpSent() !== 'true'
    && getIsOTPValidated() !== 'true'
    && !botAwaitingSelection
  );

  const isFreeTextExpected = () => {
    if (altMobileOtpRedirectTimerRef.current) {
      return false;
    }
    return isFreeTextInputExpected({
    isDateOnlyStep: isDateOnlyStep(),
    isOtpEntryStep: isOtpEntryStep() || isAlternateMobileOtpStep(),
    botAwaitingSelection,
    stepExpectsFreeText: (
      allowFreeTextInput
      || isAddressPincodeStep()
      || isAddressTextStep()
      || isAlternateMobileContext()
      || isRiderConcernStep('describe')
    ),
    isIdentifierEntryStep: isIdentifierEntryStep(),
  });
  };

  const handleInputSubmit = async () => {

    try {
      if (userInput.trim()) {
        const currentFlow = getCurrentFlow();
        const trimmedInput = userInput.trim();
        if (!isFreeTextExpected()) {
          setUserInput('');
          return;
        }
        setSelectedMessages((prevMessages) => [...prevMessages, { type: 'user', text: userInput, timestamp: returnTime() }]);

        logMessage('user', userInput);
        const isOtpValidatedSession = getIsOTPValidated() === 'true';
        const normalizedFreeText = trimmedInput.toLowerCase();
        const isTypedWhereShipment = normalizedFreeText === WHERE_IS_MY_SHIPMENT.toLowerCase();
        const isTypedShipmentConcerns = isNdrShipmentConcernsButton(trimmedInput);
        const isTypedRiderConcerns = isRiderConcernsMenuButton(trimmedInput);
        if (isOtpValidatedSession && (isTypedWhereShipment || isTypedShipmentConcerns || isTypedRiderConcerns)) {
          await handleButtonClick(trimmedInput, { skipUserEcho: true });
          setUserInput('');
          handlePlaceholderChange('');
          setHomeIcon(true);
          return;
        }
        if (getCurrentFlow() === RIDER_CONCERN_FLOW && sessionStorage.getItem('rider_concern_step')) {
          await handleRiderConcernInput(trimmedInput);
          setHomeIcon(true);
          return;
        }
        if (isAlternateMobileOtpStep()) {
          await submitAlternateMobileOtpVerification(trimmedInput);
          setUserInput('');
          setHomeIcon(true);
          return;
        }
        // Context-first routing: the expected input type comes from the
        // conversation state, never from the digit count of what was typed.
        if (isAlternateMobileContext()) {
          await submitAlternateMobileNumber(trimmedInput);
          setUserInput('');
          handlePlaceholderChange('');
          setHomeIcon(true);
          return;
        }
        if (isAddressPincodeStep()) {
          await submitAddressPincode(trimmedInput);
          setUserInput('');
          handlePlaceholderChange('');
          setHomeIcon(true);
          return;
        }
        if (isAddressTextStep()) {
          await submitAddressText(trimmedInput);
          setUserInput('');
          handlePlaceholderChange('');
          setHomeIcon(true);
          return;
        }

        // While an OTP is pending, only a 6-digit OTP is accepted.
        if (getIsOtpSent() === 'true' && getIsOTPValidated() !== 'true' && !/^\d{6}$/.test(trimmedInput)) {
          setUserInput('');
          const otpFailStatus = recordOtpFailure();
          if (otpFailStatus === 'OTP-LOCKED') {
            handleLoginOtpLocked();
          } else {
            insertMessages('Please enter a valid 6-digit OTP.');
            setHomeIcon(true);
          }
          return;
        }

        if ((trimmedInput.length === 10 && /^\d{10}$/.test(trimmedInput)) || (trimmedInput.length === 12 && trimmedInput.startsWith('91'))) {
          sessionMeta.current.mobile_number = userInput;
          const isOtpValid = getIsOTPValidated();
          if (isOtpValid === 'true') {
            await withThinkingIndicator(async () => {
              const finalData = await fetchIntentsFromStorage(userInput);
              insertMessages(finalData);
              if (!Array.isArray(finalData)) {
                await fetchResponsesInternal(additionalOptions, false);
              }
            });
          } else {
            setAWBValue(userInput);
            await withThinkingIndicator(async () => {
              const otpResult = await sendOTPFunction(userInput);
              if (!otpResult?.success) {
                insertMessages(otpResult?.message || constants.INVALID_MOBILE_MESSAGE);
                setUserInput('');
                handlePlaceholderChange('');
                setHomeIcon(true);
                return;
              }
              await fetchResponsesInternal(otpKey, false);
            });
          }
        } else if (trimmedInput.length === 6) {
          // #features_pxb5559 changes done for future pickup and auto sent OTP
          const isOtpSent = getIsOtpSent();
          if (isOtpSent == 'true') {
            let resp;
            let respStatus;
            await withThinkingIndicator(async () => {
              resp = await validateOTPFunction(userInput);
              setUserInput('');
              respStatus = resp && resp.status ? resp.status : resp;
              if (respStatus === 'MOBILE-INVALID') {
                insertMessages(resp?.message || constants.INVALID_MOBILE_MESSAGE);
                return;
              }
              if (respStatus === 'OTP-LOCKED') {
                return;
              }
              await fetchResponsesInternal(respStatus, false);
            });
            if (respStatus === 'MOBILE-INVALID') {
              return;
            }
            // If locked, show message first, then redirect to welcome
            if (respStatus === 'OTP-LOCKED') {
              handleLoginOtpLocked();
              return;
            }
            const isOtpValid = getIsOTPValidated();
            if (isOtpValid == 'true') {
              startSessionAnalytics({
                shippingId: sessionMeta.current.shippingId || getAWBValue() || '',
                mobile_number: sessionMeta.current.mobile_number || '',
              });
              const otpHasStatusPayload = Boolean(
                resp
                && (resp.latestStatus || resp.shipmentSnapshot)
              );
              if (otpHasStatusPayload) {
                if (resp.latestStatus) {
                  setLatestShipmentStatus(resp.latestStatus);
                  setCurrentFlow(resp.latestStatus);
                }
                shipmentPddData.current = {
                  pddBreach: resp.pddBreach || 'false',
                  pdd: resp.pdd || '',
                  latestStatus: resp.latestStatus || '',
                  awb: getAWBValue()
                };
                const latestStatus = String(resp.latestStatus || '').toLowerCase();
                if (
                  latestStatus === 'ndr'
                  || latestStatus === 'npr'
                  || latestStatus === 'npr_pickup_not_done'
                  || latestStatus === 'rpcancel'
                ) {
                  if (resp.shipmentSnapshot) {
                    applyOtpShipmentSnapshot(resp.shipmentSnapshot, resp.latestStatus);
                  } else if (latestStatus === 'ndr' && getAWBValue()) {
                    await hydrateForwardNdrShipmentContext(getAWBValue());
                  }
                }
              }
              // Enquiry-menu statuses render Mongo buttons; RPCancel has no menu.
              const otpEnvelopeHasSelectableButtons = (otpResp) => {
                if (!otpResp?.buttons?.length) {
                  return false;
                }
                const optionText = (item) => (
                  item?.content ?? item?.context ?? item?.key ?? item?.text ?? ''
                );
                return otpResp.buttons.some((item) => {
                  if (!item || typeof item !== 'object') {
                    return false;
                  }
                  if (Array.isArray(item.buttons)) {
                    return item.buttons.some(
                      (btn) => btn
                        && (btn.type || 'button') !== 'text'
                        && optionText(btn)
                    );
                  }
                  return item.type === 'button' || Boolean(optionText(item));
                });
              };
              if (otpEnvelopeHasSelectableButtons(resp)) {
                insertMessages(resp.buttons);
                return;
              }
              const rpcancelStatus = String(
                resp?.latestStatus || getLatestShipmentStatus() || ''
              ).toLowerCase();
              if (rpcancelStatus === 'rpcancel') {
                let nprSnapshot = getNprShipmentSnapshot();
                if (!nprSnapshot && getAWBValue()) {
                  await fetchIntentOfInput(getAWBValue(), true);
                  nprSnapshot = getNprShipmentSnapshot();
                }
                if (nprSnapshot && isRpcancelShipment(nprSnapshot)) {
                  const rpcancelFlowResponse = await routeRpcancelSpecialFlows(nprSnapshot);
                  if (rpcancelFlowResponse) {
                    insertMessages(rpcancelFlowResponse);
                    await applyPostOrderStatusFlowEffects(rpcancelFlowResponse, getAWBValue());
                    return;
                  }
                }
              }
              const finalData = await fetchIntentsFromStorage();
              // Capture PDD data into memory ref before any clearSelectedKeys wipes session storage
              shipmentPddData.current = { pddBreach: getPddBreach(), pdd: getEDD() };
              insertMessages(finalData);
              await applyPostOrderStatusFlowEffects(finalData, getAWBValue());
              if (!Array.isArray(finalData) && String(finalData).toLowerCase().includes('enter your pincode below')) {
                setAddressUpdateStep('pincode');
              }
              if (String(finalData || '').includes('Sorry')) {
                // clearSelectedKeys(clearSessionKeys);
                fetchResponses(additionalOptions, false);
              } else if (String(finalData || '').includes('is not a')) {
                createTicket()
                fetchResponses(additionalOptions, false);
              } else if (currentFlow.includes('future date') || currentFlow.includes('future pickup')) {
                if (!Array.isArray(finalData))
                  fetchResponses(`${currentFlow} - confirmation`, true)
              } else if (getIntentTicket().includes('complaint')) {
                if (!Array.isArray(finalData))
                  fetchResponses(complaintConfirmation, false)
              } else if (currentFlow.includes('alternate')) {
                if (finalData && finalData.length > 0) {
                  if (!Array.isArray(finalData)) {
                    if (getNumber()) {
                      fetchResponses(`${currentFlow} - confirmation`, true)
                    } else {
                      fetchResponses(`${currentFlow} - shipment`, false);
                    }
                  }
                }
              } else if (await tryHandleWhereIsMyShipmentSpecialFlow()) {
                return;
              } else if (getIntentName().includes("order-status")) {
                if (!Array.isArray(finalData)) {
                  createTicket();
                  fetchResponses(additionalOptions, false);
                }
              } else if (getButtonName() === WHERE_IS_MY_SHIPMENT) {
                const msg = await withThinkingIndicator(
                  () => getWhereIsMyShipmentMessage(shipmentPddData.current.pddBreach, shipmentPddData.current.pdd)
                );
                insertMessages(msg);
                clearSelectedKeys(clearSessionKeys);
                fetchResponses(additionalOptions, false);
              }
            }
          } else if (getIsOTPValidated() === 'true') {
            // 6-digit input is never an AWB. Do not overwrite shipment id with a pincode.
            insertMessages('Please enter a valid 6-digit pincode, or select an option from the menu.');
            setUserInput('');
            return;
          } else {
            await startShipmentOtpFlow(userInput);
            setUserInput('');
          }
        } else {
          // #enhancements_pxb5559 changes done according workflow enhancements
          const buttonName = getButtonName();
          // Address-update typed input must go through validate-pincode (serviceability
          // API) or submitAddressText — never call update-contact-address directly.
          // Only while an address step is active; otherwise option buttons own the UX.
          if (
            (buttonName === `${UPDATE_CONTACT_ADDRESS} - YES` || currentFlow === UPDATE_CONTACT_ADDRESS)
            && (getAddressUpdateStep() === 'pincode' || getAddressUpdateStep() === 'address')
          ) {
            if (getAddressUpdateStep() === 'address') {
              await submitAddressText(trimmedInput);
            } else {
              await submitAddressPincode(trimmedInput);
            }
            setUserInput('');
            handlePlaceholderChange('');
            setHomeIcon(true);
            return;
          }

          let isShipmentValid = await getShipmentTypeFromInput(userInput);
          if (isShipmentValid !== 'true') {
            insertMessages(isShipmentValid);
            setUserInput('');
            handlePlaceholderChange('');
            fetchHomeButtons();
            return;
          }
          if (getIsOTPValidated() === 'true') {
            setAWBValue(userInput);
            sessionMeta.current.shippingId = userInput;
            await fetchShipmentDetails(userInput);
          } else {
            await startShipmentOtpFlow(userInput);
          }
        }
        setUserInput('');
        handlePlaceholderChange('');
        setHomeIcon(true);
      }
    } catch (error) {
      console.log('Error handling input submit:', error)
    }
  };


  const handleButtonClick = async (message, options = {}) => {
    try {
      const { skipUserEcho = false } = options;
      const trimmedMessage = String(message || '').trim();

      if (trimmedMessage === IVR_CALL_LOG_CALENDAR_OPEN_BUTTON) {
        if (sessionStorage.getItem('ivr_calendar_date_selected') === 'true') {
          return;
        }
        if (selectedMessages.some((m) => m?.isType === 'calendar' && !m.calendarLocked)) {
          return;
        }
        setSelectedMessages((prevMessages) => [
          ...prevMessages.filter((msg) => !Array.isArray(msg) && msg.isType !== 'button'),
          { type: 'user', text: trimmedMessage, timestamp: returnTime() },
          {
            type: 'server',
            isType: 'calendar',
            text: '',
            calendarActive: true,
            calendarLocked: false,
            timestamp: returnTime(),
          },
        ]);
        logMessage('user', trimmedMessage);
        setShowInput(true);
        setBotAwaitingSelection(true);
        setAllowFreeTextInput(false);
        handlePlaceholderChange('Please select a date from the calendar.');
        setHomeIcon(true);
        return;
      }

      const shipmentId = extractShipmentId(message);
      if (shipmentId) {
        message = `Shipment ID: ${shipmentId}`;
      }
      if (!skipUserEcho) {
        setSelectedMessages((prevMessages) => [
          ...prevMessages.filter(msg => !Array.isArray(msg) && msg.isType !== 'button'),
          { type: 'user', text: message, timestamp: returnTime() }
        ]);
        logMessage('user', message);
      }
      setShowInput(true);
      // Keep the box locked until the next bot message decides whether typing
      // is expected, so nothing can be sent while the reply is in flight.
      setBotAwaitingSelection(true);
      setAllowFreeTextInput(false);
      handlePlaceholderChange('Please select the appropriate response.');
      setHomeIcon(true);

      // Rider concern incident date (calendar / IVR button) — handle before YES/NO routing.
      if (
        getCurrentFlow() === RIDER_CONCERN_FLOW
        && sessionStorage.getItem('rider_concern_step') === 'date'
      ) {
        const incidentWhen = parseRiderIncidentWhen(message);
        if (incidentWhen) {
          await completeRiderConcern(incidentWhen);
          return;
        }
      }

      if (isNprPickupBackendContext()) {
        if (
          NPR_BACKEND_RTO_AGREE_LABELS.includes(trimmedMessage)
          || NPR_BACKEND_RTO_DISAGREE_LABELS.includes(trimmedMessage)
        ) {
          await delegateNprPickupFetchRecords(trimmedMessage);
          return;
        }
        if (
          isNprBackendCallLogLabel(trimmedMessage)
          && !IVR_CALL_LOG_DISAGREE_FLOWS.includes(getCurrentFlow())
        ) {
          await delegateNprPickupFetchRecords(trimmedMessage, { followWithStillHaveQuery: true });
          return;
        }
      }

      // Handle feedback responses
      if (awaitingFeedback) {
        if (feedbackHandled.current) return; // guard against double-click
        feedbackHandled.current = true;
        setAwaitingFeedback(false);
        const normalizedMsg = message.toUpperCase();

        // Save feedback to backend
        try {
          const payload = {
            sessionId: getSessionId(),
            shippingId: sessionMeta.current.shippingId || getAWBValue() || "",
            user_feedback: normalizedMsg
          };
          const endpoint = config.chatbotbackendapi.replace('/webhook', '/chat/save-feedback');
          fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          }).catch(err => console.error("Error saving feedback:", err));
        } catch (error) {
          console.error("Error in feedback API:", error);
        }

        const feedbackMsg = normalizedMsg === 'YES'
          ? 'Thank you for your feedback. Glad we could help!'
          : 'Thank you for your feedback. We are really sorry for the experience today and we\'ll strive to do better';
        setSelectedMessages((prev) => [
          ...prev.filter(msg => !Array.isArray(msg) && msg.isType !== 'button'),
          { type: 'server', text: feedbackMsg, isType: 'text', timestamp: returnTime() },
        ]);
        logMessage('chatBot', feedbackMsg);
        await flushConversation();
        await endSessionAnalytics({
          endedReason: 'feedback_done',
          shippingId: sessionMeta.current.shippingId || getAWBValue() || '',
        });
        // Reset session after a short delay so user can read the message
        setTimeout(() => {
          clearSessionStorage();
          shipmentPddData.current = { pddBreach: null, pdd: '', latestStatus: '', awb: '' };
          feedbackHandled.current = false;
          resetAltNumRetry();
          setAwaitingCancelConfirm(false);
          setHomeIcon(false);
          fetchHomeButtons();
          handlePlaceholderChange(validInputPrompt);
        }, 5000);
        return;
      }
      // "No,thanks" / "No,thanks." — still-have-query No
      if (
        getCurrentFlow() === STILL_HAVE_QUERY
        && isStillHaveQueryNoChoice(message)
      ) {
        // Delivered closing only: thank you → Can I assist you with something else?
        if (isDeliveredClosingFlow()) {
          await insertMessages('Thank you for your feedback.');
          await finishDeliveredClosingToAdditionalOptions();
          return;
        }
        // Other flows: thank you, then reset session
        await insertMessages('Thank you for your feedback.');
        await flushConversation();
        await endSessionAnalytics({
          endedReason: 'still_have_query_no',
          shippingId: sessionMeta.current.shippingId || getAWBValue() || '',
        });
        setTimeout(() => {
          clearSessionStorage();
          shipmentPddData.current = { pddBreach: null, pdd: '', latestStatus: '', awb: '' };
          resetAltNumRetry();
          setAwaitingCancelConfirm(false);
          setHomeIcon(false);
          fetchHomeButtons();
          handlePlaceholderChange(validInputPrompt);
        }, 2000);
        return;
      }
      // #enhancements_pxb5559 changes done according workflow enhancements
      const currentFlow = getCurrentFlow() || getButtonName();

      const normalizedMsg = message.trim().toUpperCase();
      if (normalizedMsg === "YES") {
        const isOtpValid = getIsOTPValidated();
        const shipmentStatus = getShipmentStatus();
        const attemptCount = getAttemptCount();
        // Delivered closing only: still-have-query Yes → customer care connect
        if (getCurrentFlow() === STILL_HAVE_QUERY && isDeliveredClosingFlow()) {
          setCurrentFlow(CUSTOMER_CARE_CONNECT_PROMPT);
          await fetchResponses('Yes,I have', true);
          setCurrentFlow(CUSTOMER_CARE_CONNECT_PROMPT);
          return;
        }
        if (isDeliveredNotReceivedAgreementContext()) {
          configureDeliveredAgreementYesTicket();
          await withThinkingIndicator(() => createStatusTicket(getAWBValue(), 'order-status-ticket'));
          await insertMessages(CWFD_AGREE_THANKS);
          await promptDeliveredStillHaveQuery();
          return;
        }
        if (getCurrentFlow() === NDR_CWFD_AGREEMENT || getCurrentFlow() === NDR_CRA_AGREEMENT || getCurrentFlow() === NDR_ADI_AGREEMENT || getCurrentFlow() === NPR_ADI_AGREEMENT || getCurrentFlow() === NPR_HANDED_AGREEMENT || getCurrentFlow() === RPCANCEL_PICKUP_AGREEMENT || getCurrentFlow() === NPR_CWFP_AGREEMENT) {
          const flow = getCurrentFlow();
          if (flow === RPCANCEL_PICKUP_AGREEMENT || flow === NPR_ADI_AGREEMENT) {
            // RVP row 13 / NPR ADI agree — Enquiry / Shipment status / Call status-Agreed / Closed
            configureRpcancelPickupAgreementYesTicket();
          } else {
            configureNdrAgreementYesTicket();
          }
          await createStatusTicket(getAWBValue(), 'order-status-ticket');
          await insertMessages(flow === NPR_ADI_AGREEMENT ? NPR_ADI_AGREE_THANKS : CWFD_AGREE_THANKS);
          if (flow === NDR_CRA_AGREEMENT) {
            setCurrentFlow(NDR_CRA_FLOW_END);
          } else if (flow === NDR_ADI_AGREEMENT) {
            setCurrentFlow(NDR_ADI_FLOW_END);
          } else if (flow === NPR_ADI_AGREEMENT) {
            setCurrentFlow(NPR_ADI_FLOW_END);
          } else if (flow === RPCANCEL_PICKUP_AGREEMENT) {
            setCurrentFlow(RPCANCEL_PICKUP_FLOW_END);
          } else if (flow === NPR_CWFP_AGREEMENT) {
            setCurrentFlow(NPR_CWFP_FLOW_END);
          } else if (flow === NPR_HANDED_AGREEMENT) {
            setCurrentFlow(NPR_HANDED_FLOW_END);
          } else {
            setCurrentFlow(NDR_CWFD_FLOW_END);
          }
          return;
        }
        if (getCurrentFlow() === NDR_PNC_RESCHEDULE || isPncReschedulePending()) {
          setPncReschedulePending(false);
          setCurrentFlow(NDR_PNC_DATE_SELECTION);
          setIntentName('update-delivery-date');
          setIntentTicket('update-delivery-date-yes');
          const dateOptions = await getFutureDeliveryDates([
            { type: 'text', content: PNC_SELECT_DATE_PROMPT },
          ]);
          await insertMessages(dateOptions);
          return;
        }
        if (getCurrentFlow() === RPCANCEL_REFUND_RESCHEDULE) {
          setCurrentFlow(RPCANCEL_REFUND_DATE_SELECTION);
          setIntentValue('59');
          setIntentName('update-pickup-date');
          setIntentTicket('update-pickup-date-yes');
          const dateOptions = await fetchRefundPickupDateOptions();
          insertMessages(dateOptions);
          return;
        }
        // Handle cancel order confirmation
        if (awaitingCancelConfirm) {
          setAwaitingCancelConfirm(false);
          return createCancelTicket();
        }
        // Pending-for-Pickup cancel confirmation. The confirmation card lives
        // inside our custom "I want to cancel my pickup" flow doc, so neither
        // awaitingCancelConfirm nor currentFlow === CANCEL_ORDER are true. If
        // we fell through to the generic `fetchResponses(currentFlow - Yes)`
        // path, the backend's text success response would be discarded by
        // fetchOptionsOfInput (which only renders `buttons` responses on
        // fetch-records), and the user would see the confirmation card frozen
        // even though the CRM ticket was created. Route through the same
        // createCancelTicket() helper the forward-cancel path already uses so
        // the ticket-number success message renders correctly.
        {
          const _latestStatusYes = shipmentPddData.current.latestStatus || getLatestShipmentStatus();
          if ((isReversePickupHubContext())
              && currentFlow === 'I want to cancel my pickup') {
            return createCancelTicket();
          }
        }
        // Pickup-done agreement Yes — backend creates closed Enquiry 295 and thanks.
        if (isPickupDoneContext() && currentFlow === 'My shipment has not been picked') {
          setButtonName('My shipment has not been picked - Yes');
          const agreeResp = await fetchRecordsWithThinking('My shipment has not been picked - Yes');
          await insertMessages(agreeResp);
          return;
        }
        if (isCustomerCareConnectPromptFlow(currentFlow)) {
          setButtonName(`${currentFlow} - Yes`);
          const connectResp = await fetchRecordsWithThinking(`${currentFlow} - Yes`);
          await insertMessages(connectResp);
          // Delivered closing only: then Can I assist you with something else?
          if (isDeliveredClosingFlow()) {
            await finishDeliveredClosingToAdditionalOptions();
          }
          return;
        }
        // #enhancements_pxb5559 changes done according workflow enhancements
        if (isOtpValid == 'false') {
          const mobileNo = getNumber();
          if (mobileNo) {
            sendOTPFunction(mobileNo);
            fetchResponses(otpKey, false);
          } else {
            fetchResponses(promptOfNumber, false);
          }
        } else if (getIntentName().includes('complaint') && currentFlow !== SHIPMENT_NOT_RECEIVED && currentFlow !== PRODUCT_NOT_PICKED) {
          createComplaintTicket();
        } else if (currentFlow === PRODUCT_NOT_PICKED && ((shipmentStatus === 'Manifestation' && attemptCount === 0) || shipmentStatus === "OFP" || shipmentStatus === "DTO")) {
          createComplaintTicket();
        } else if (isOtpValid == 'false') {
          const mobileNo = getNumber();
          if (mobileNo) {
            sendOTPFunction(mobileNo);
            fetchResponses(otpKey, false);
          } else {
            fetchResponses(promptOfNumber, false);
          }
        } else {
          // #enhancements_pxb5559 changes done according workflow enhancements
          let msg = message;
          if (currentFlow === SHIPMENT_NOT_RECEIVED && (shipmentStatus === "Manifestation" || shipmentStatus === "OFD" || shipmentStatus === "RTO" || (shipmentStatus === "Inscan" && attemptCount === 0))) {
            setIntentValue("23");
            createComplaintTicket();
            return;
          } else if ((currentFlow === SHIPMENT_NOT_RECEIVED && shipmentStatus === 'Delivered') || (currentFlow === PRODUCT_NOT_PICKED && shipmentStatus === 'PickedUp')) {
            // let prompt = shipmentStatus === "Delivered" ? "Shipment is already delivered." : "Shipment is already picked. If you have any other concerns, feel free to let us know!";
            let ndrMessage = await getTicketDetails();
            if (ndrMessage && ndrMessage.length > 0 && ndrMessage[1] !== '') {
              insertMessages(ndrMessage[1]);
            }
            msg = shipmentStatus;
          } else if (currentFlow === SHIPMENT_NOT_RECEIVED && (shipmentStatus === "Inscan" && attemptCount >= 1)) {
            let ndrMessage = await getTicketDetails();
            if (ndrMessage && ndrMessage.length > 0 && ndrMessage[1] !== '') {
              insertMessages(ndrMessage[1]);
            }
            msg = "NDR"
          } else if (currentFlow === PRODUCT_NOT_PICKED && (shipmentStatus === "Manifestation" && attemptCount >= 1)) {
            let nprMessage = await getTicketDetails();
            if (nprMessage && nprMessage.length > 0 && nprMessage[1] !== '') {
              insertMessages(nprMessage[1]);
            }
            msg = "NPR"
          } else if (currentFlow === FUTURE_DATE_DELIVERY && (((shipmentStatus === "Manifestation" || shipmentStatus === "OFD" || shipmentStatus === "Inscan") && attemptCount === 0) || shipmentStatus === "Delivered" || shipmentStatus === "RTO")) {
            console.log(">>>>>>>>>>>>>>>>>>>>>FUTURE_DATE_DELIVERY");

            return createComplaintTicket();
          } else if (currentFlow === FUTURE_PICKUP_DATE && (((shipmentStatus === "Manifestation" || shipmentStatus === "Inscan" || shipmentStatus === "OFP") && attemptCount === 0) || shipmentStatus === "PickedUp" || shipmentStatus === "DTO")) {

            return createComplaintTicket();
          } else if (currentFlow === CANCEL_ORDER) {
            return createCancelTicket();
          } else if (currentFlow === UPDATE_CONTACT_ADDRESS) {
            // User confirmed address update — create ticket now
            await finalizeAddressUpdate();
            return;
          }
          fetchResponses(`${currentFlow} - ${msg}`, true);
        }
      } else if (normalizedMsg === "NO") {
        // Delivered closing only: still-have-query No → thank you → additional options
        if (getCurrentFlow() === STILL_HAVE_QUERY && isDeliveredClosingFlow()) {
          await insertMessages('Thank you for your feedback.');
          await finishDeliveredClosingToAdditionalOptions();
          return;
        }
        // Pending-for-Pickup cancel decline. The confirmation card sits INSIDE
        // our custom "I want to cancel my pickup" flow doc; awaitingCancelConfirm
        // is not set (that's a forward-cancel flag) and currentFlow is not
        // CANCEL_ORDER, so without this branch we'd fall through to just
        // `fetchResponses(additionalOptions)` and the user would never see the
        // "No changes made" acknowledgement the flowchart specifies.
        if (isReversePickupHubContext()
            && currentFlow === 'I want to cancel my pickup') {
          insertMessages('No changes made! Thankyou');
          fetchResponses(additionalOptions, false);
          return;
        }
        // Pickup-done agreement No — backend creates Complaint 296-rvp + ticket message.
        if (isPickupDoneContext() && currentFlow === 'My shipment has not been picked') {
          setButtonName('My shipment has not been picked - No');
          const disagreeResp = await fetchRecordsWithThinking('My shipment has not been picked - No');
          await insertMessages(disagreeResp);
          return;
        }
        if (getCurrentFlow() === NDR_CWFD_AGREEMENT) {
          setCurrentFlow(NDR_CWFD_CALL_LOG);
          insertMessages(await buildCwfdCallLogOptions());
          return;
        }
        if (getCurrentFlow() === NDR_CRA_AGREEMENT) {
          setCurrentFlow(NDR_CRA_CALL_LOG);
          insertMessages(await buildCraCallLogOptions());
          return;
        }
        if (getCurrentFlow() === NDR_ADI_AGREEMENT) {
          setCurrentFlow(NDR_ADI_CALL_LOG);
          insertMessages(await buildAdiCallLogOptions());
          return;
        }
        if (getCurrentFlow() === NPR_ADI_AGREEMENT) {
          setCurrentFlow(NPR_ADI_CALL_LOG);
          insertMessages(await buildNprAdiCallLogOptions());
          return;
        }
        if (getCurrentFlow() === NPR_HANDED_AGREEMENT) {
          setCurrentFlow(NPR_HANDED_CALL_LOG);
          insertMessages(await buildHandedCallLogOptions());
          return;
        }
        if (getCurrentFlow() === NPR_CWFP_AGREEMENT) {
          setCurrentFlow(NPR_CWFP_CALL_LOG);
          insertMessages(await buildHandedCallLogOptions());
          return;
        }
        if (getCurrentFlow() === RPCANCEL_PICKUP_AGREEMENT) {
          setCurrentFlow(RPCANCEL_PICKUP_CALL_LOG);
          await insertMessages(await buildCancelledPickupCallLogOptions());
          return;
        }
        if (getCurrentFlow() === NDR_PNC_RESCHEDULE || isPncReschedulePending()) {
          setPncReschedulePending(false);
          setCurrentFlow(NDR_PNC_FLOW_END);
          await insertMessages(PNC_NO_CHANGES_MSG);
          await fetchResponses(additionalOptions, false);
          return;
        }
        if (getCurrentFlow() === RPCANCEL_REFUND_RESCHEDULE) {
          insertMessages(RPCANCEL_REFUND_NO_CHANGES_MSG);
          setCurrentFlow(RPCANCEL_REFUND_FLOW_END);
          fetchResponses(additionalOptions, false);
          return;
        }
        if (isCustomerCareConnectPromptFlow(currentFlow)) {
          // Delivered closing: keep session open and continue to additional options
          if (isDeliveredClosingFlow()) {
            await insertMessages('Hope you have a great day!');
            await finishDeliveredClosingToAdditionalOptions();
            return;
          }
          setButtonName(`${currentFlow} - No`);
          const connectResp = await fetchRecordsWithThinking(`${currentFlow} - No`);
          await insertMessages(connectResp);
          return;
        }
        if (awaitingCancelConfirm) {
          setAwaitingCancelConfirm(false);
          insertMessages('No changes made! Thankyou');
          fetchResponses(additionalOptions, false);
        } else if (currentFlow === CANCEL_ORDER) {
          insertMessages('No changes made! Thankyou');
          fetchResponses(additionalOptions, false);
        } else if (currentFlow === UPDATE_CONTACT_ADDRESS) {
          // User declined address update
          insertMessages('No worries! Your address remains unchanged and your delivery will proceed as scheduled.');
          sessionStorage.removeItem('update_address_pincode');
          sessionStorage.removeItem('update_address_text');
          setAddressUpdateStep('');
          setAdiPostAddressPending(false);
          fetchResponses(additionalOptions, false);
          return;
        } else if (isDeliveredNotReceivedAgreementContext(currentFlow) || isDeliveredNotReceivedAgreementContext()) {
          // Delivered fake-delivery disagree — complaint 134, then still-have-query (not additional options)
          const ticketResp = await fetchRecordsWithThinking(`${DELIVERED_NOT_RECEIVED} - No`);
          if (ticketResp) {
            await insertMessages(ticketResp);
          }
          const respBlob = JSON.stringify(ticketResp || []).toLowerCase();
          const alreadyHasStillHaveQuery = (
            respBlob.includes('still have a query')
            || respBlob.includes('yes,i have')
          );
          if (!alreadyHasStillHaveQuery) {
            await promptDeliveredStillHaveQuery();
          } else {
            setDeliveredClosingFlow(true);
            setCurrentFlow(STILL_HAVE_QUERY);
          }
          return;
        } else {
          fetchResponses(additionalOptions, false);
        }
      } else if (shipmentId) {
        setAWBValue(shipmentId);
        sessionMeta.current.shippingId = shipmentId;
        const isOtpValid = getIsOTPValidated();
        // Mobile/OTP flow: user selected a shipping ID from the list — fetch status-based buttons
        if (isOtpValid === 'true') {
          const payload = await createSelectShippingIdPayload(shipmentId);
          const response = await fetch(config.chatbotbackendapi, await fetchHeaders(payload));
          if (response.ok) {
            const result = await response.json();
            if (result && result.response && result.response.length > 0) {
              const buttonsMsg = result.response.find(r => r.buttons);
              if (buttonsMsg) {
                if (buttonsMsg.latestStatus) {
                  setLatestShipmentStatus(buttonsMsg.latestStatus);
                  shipmentPddData.current = {
                    pddBreach: buttonsMsg.pddBreach || 'false',
                    pdd: buttonsMsg.pdd || '',
                    latestStatus: buttonsMsg.latestStatus || '',
                    awb: shipmentId
                  };
                }
                insertMessages(result.response);
                return;
              }
            }
          }
          // fallback if backend didn't return buttons
          insertMessages('Sorry, could not fetch options for this shipment. Please try again.');
          return;
        }
        await startShipmentOtpFlow(shipmentId);
        return;
      } else if (message == "Surely not received.") {
        setIntentValue("23");
        createComplaintTicket();
      } else if (message == "Request a new OTP") {
        const mobileNo = getNumber();
        if (mobileNo) {
          sendOTPFunction(mobileNo);
          fetchResponses(otpKey, false);
        } else {
          fetchResponses(promptOfNumber, false);
        }
      } else if (message == "Go back to Home") {
        handleHomeButtonClick();
      } else {
        // Rider concern incident-date step — IVR "DD-MM-YYYY | HH:MM:SS" buttons.
        // Must run before NDR/NPR call-log handlers so those tickets are not raised by mistake.
        if (
          getCurrentFlow() === RIDER_CONCERN_FLOW
          && sessionStorage.getItem('rider_concern_step') === 'date'
        ) {
          const incidentWhen = parseRiderIncidentWhen(message);
          if (incidentWhen) {
            await completeRiderConcern(incidentWhen);
            return;
          }
        }
        // #enhancements_pxb5559 changes done according workflow enhancements
        // Legacy: "OTP/CALL/IVR - <LastNDRDateTime>". New: "DD-MM-YYYY | HH:MM:SS" from IVR StartTime.
        const isCwfdAttemptButton = (
          /^(OTP|CALL|IVR)\s*-/i.test(String(message || '').trim())
          || /^\d{2}-\d{2}-\d{4}(\s*\|\s*\d{2}:\d{2}(?::\d{2})?)?$/.test(String(message || '').trim())
        );
        if (getCurrentFlow() === NDR_CWFD_CALL_LOG || (isCwfdAttemptButton && isNdrCwfdFlow())) {
          setCurrentFlow(NDR_CWFD_CALL_LOG);
          setButtonName(message);
          setIntentValue("296");
          setIntentTicket('complaint-raise-not-received-ticket');
          const ticketData = await createComplintTicket(getAWBValue(), 'complaint-raise-not-received-ticket');
          insertMessages(ticketData || "Sorry, we could not register your complaint right now. Please try again.");
          setCurrentFlow(NDR_CWFD_FLOW_END);
          return;
        }
        if (getCurrentFlow() === NDR_CRA_CALL_LOG || (isCwfdAttemptButton && isNdrCraFlow())) {
          setCurrentFlow(NDR_CRA_CALL_LOG);
          setButtonName(message);
          setIntentValue("296");
          setIntentTicket('complaint-raise-not-received-ticket');
          const ticketData = await createComplintTicket(getAWBValue(), 'complaint-raise-not-received-ticket');
          insertMessages(ticketData || "Sorry, we could not register your complaint right now. Please try again.");
          setCurrentFlow(NDR_CRA_FLOW_END);
          return;
        }
        if (getCurrentFlow() === NDR_ADI_CALL_LOG || (isCwfdAttemptButton && isNdrAdiFlow())) {
          setCurrentFlow(NDR_ADI_CALL_LOG);
          setButtonName(message);
          setIntentValue("296");
          setIntentTicket('complaint-raise-not-received-ticket');
          const ticketData = await createComplintTicket(getAWBValue(), 'complaint-raise-not-received-ticket');
          insertMessages(ticketData || "Sorry, we could not register your complaint right now. Please try again.");
          setCurrentFlow(NDR_ADI_FLOW_END);
          return;
        }
        if (getCurrentFlow() === NPR_ADI_CALL_LOG || (isCwfdAttemptButton && isNprAdiFlow())) {
          setCurrentFlow(NPR_ADI_CALL_LOG);
          setButtonName(message);
          configureNprAdiDisagreeTicket();
          const awb = getAWBValue() || shipmentId;
          const ticketData = await createComplintTicket(awb, 'complaint-raise-not-received-ticket');
          insertMessages(ticketData || "Sorry, we could not register your complaint right now. Please try again.");
          setCurrentFlow(NPR_ADI_FLOW_END);
          await promptStillHaveQuery();
          return;
        }
        if (getCurrentFlow() === NPR_HANDED_CALL_LOG || (isCwfdAttemptButton && isNprHandedFlow())) {
          setCurrentFlow(NPR_HANDED_CALL_LOG);
          setButtonName(message);
          // NPR Reason sheet row 22 — Call status-Disagreed (296)
          configureNprHandedDisagreeTicket();
          const awb = getAWBValue() || shipmentId;
          const ticketData = await createComplintTicket(awb, 'complaint-raise-not-received-ticket');
          insertMessages(ticketData || "Sorry, we could not register your complaint right now. Please try again.");
          setCurrentFlow(NPR_HANDED_FLOW_END);
          await promptStillHaveQuery();
          return;
        }
        if (getCurrentFlow() === RPCANCEL_PICKUP_CALL_LOG || (isCwfdAttemptButton && isRpcancelPickupFlow())) {
          setCurrentFlow(RPCANCEL_PICKUP_CALL_LOG);
          setButtonName(message);
          // RVP row 14 — Complaint / Call status-Disagreed / Open (created with ticket message)
          configureRpcancelPickupDisagreeTicket();
          const awb = getAWBValue() || shipmentId;
          const ticketData = await createComplintTicket(awb, 'complaint-raise-not-received-ticket');
          await insertMessages(ticketData || "Sorry, we could not register your complaint right now. Please try again.");
          setCurrentFlow(RPCANCEL_PICKUP_FLOW_END);
          return;
        }
        if (getCurrentFlow() === NPR_CWFP_CALL_LOG || (isCwfdAttemptButton && isNprCwfpFlow())) {
          setCurrentFlow(NPR_CWFP_CALL_LOG);
          setButtonName(message);
          setIntentValue("296");
          setIntentTicket('complaint-raise-not-received-ticket');
          const awb = getAWBValue() || shipmentId;
          const ticketData = await createComplintTicket(awb, 'complaint-raise-not-received-ticket');
          insertMessages(ticketData || "Sorry, we could not register your complaint right now. Please try again.");
          setCurrentFlow(NPR_CWFP_FLOW_END);
          await promptStillHaveQuery();
          return;
        }
        if (currentFlow === SHIPMENT_NOT_RECEIVED || currentFlow === PRODUCT_NOT_PICKED) {
          if (message === "I do not agree with the reason of non delivery provided.") {
            // fake NDR
            setButtonName(message);
            setIntentValue("133")
            createComplaintTicket();
            return;
          } else if (message === "Ok, deliver the shipment quickly.") {
            // log ticket with closed status
            setButtonName(message);
            setIntentValue("139");
            createComplaintTicket();
            return;
          } else if (message === "Yes, I have received my shipment") {
            // log ticket with closed status
            setButtonName(message);
            createComplaintTicket();
            return;
          } else if (message === "No, I have not received my shipment") {
            // fake delivery
            setButtonName(message);
            setIntentValue("134");
            createComplaintTicket();
            return;
          } else if (message === "Yes, my return shipment is picked.") {
            // log ticket with closed status 
            setButtonName(message);
            createComplaintTicket();
            return;
          } else if (message === "No, the shipment is not yet picked.") {
            // fake pickup
            setButtonName(message);
            setIntentValue("120");
            createComplaintTicket();
            return;
          } else if (message === "I do not agree with the reason for non-pickup provided.") {
            setButtonName(message);
            setIntentValue("119");
            createComplaintTicket();
            return;
          } else if (message === "Ok, Kindly pick the shipment quickly.") {
            setButtonName(message);
            setIntentValue("131");
            createComplaintTicket();
            return;
          }
        }
        if (
          getCurrentFlow() === STILL_HAVE_QUERY
          && isStillHaveQueryYesChoice(message)
        ) {
          setCurrentFlow(CUSTOMER_CARE_CONNECT_PROMPT);
          await fetchResponses('Yes,I have', true);
          // Keep delivered closing flag so CC Yes/No can continue to additional options
          if (isDeliveredClosingFlow()) {
            setCurrentFlow(CUSTOMER_CARE_CONNECT_PROMPT);
          }
          return;
        }
        const isWhereShipment = isNdrSpecialFlowTrigger(message);
        if (isWhereShipment && !getNdrShipmentSnapshot() && getAWBValue() && getIsOTPValidated() === 'true') {
          // OTP-success can render status buttons before NDR snapshot/session context is hydrated.
          // Fetching shipment details once here ensures special-flow routing has the required context.
          await withThinkingIndicator(() => fetchIntentsFromStorage(getAWBValue()));
        }
        if (isNdrShipmentConcernsButton(message)) {
          // OFD: only path is "Where is my shipment?" — skip the single oval chip
          // hub and show the status bubble (rider/OTP) directly.
          if (isOfdContext()) {
            setButtonName(message);
            setCurrentFlow('Where is my shipment?');
            const ofdResp = await fetchRecordsWithThinking('where is my shipment?');
            await insertMessages(ofdResp);
            return;
          }
          const latestStatus = String(getLatestShipmentStatus() || '').toLowerCase();
          if (isDeliveredShipmentConcernsButton(message)) {
            setButtonName(message);
            const concernsMenu = await fetchDeliveredShipmentConcernsMenuOptions();
            insertMessages(concernsMenu);
            return;
          }
          if (latestStatus === 'ndr' && getAWBValue() && getIsOTPValidated() === 'true') {
            await hydrateForwardNdrShipmentContext(getAWBValue());
          }
          const isForwardNdrConcernsContext = isForwardNdrUserContext()
            || isNdrEnquirySessionFlow()
            || (latestStatus === 'ndr' && Boolean(getAWBValue()));
          if (isForwardNdrConcernsContext) {
            setNdrConcernsActive(true);
            setButtonName(message);
            const concernsMenu = await withThinkingIndicator(() => fetchNdrShipmentConcernsMenuOptions());
            insertMessages(concernsMenu);
            return;
          }
          // NPR: show hub sub-menu first (same pattern as NDR); special flows run on "Where is my shipment".
          if (isReverseNprUserContext()) {
            let nprSnapshot = getNprShipmentSnapshot();
            if (!nprSnapshot && getAWBValue() && isNprSpecialFlowLatestStatus(latestStatus)) {
              await fetchIntentOfInput(getAWBValue(), true);
              nprSnapshot = getNprShipmentSnapshot();
            }
            if (
              nprSnapshot
              && String(nprSnapshot.businessType || '').toLowerCase() === 'reverse'
              && isNprSpecialFlowLatestStatus(nprSnapshot)
            ) {
              setNprConcernsActive(true);
              setButtonName(message);
              const concernsMenu = await fetchNprShipmentConcernsMenuOptions();
              insertMessages(concernsMenu);
              return;
            }
          }
        }
        // OFD "Where is my shipment?" — closed Forward Shipment-status log + rider/OTP message.
        if (isOfdContext() && isNdrSpecialFlowTrigger(message)) {
          setButtonName(message);
          setCurrentFlow('Where is my shipment?');
          const ofdResp = await fetchRecordsWithThinking('where is my shipment?');
          await insertMessages(ofdResp);
          return;
        }
        if (isDeliveredNotReceivedButton(message) && isForwardDeliveredContext()) {
          setCurrentFlow(DELIVERED_NOT_RECEIVED);
          setButtonName(message);
          fetchResponses(message, true);
          return;
        }
        if (isDeliveredIncorrectShipmentButton(message) && isForwardDeliveredContext()) {
          setButtonName(message);
          configureDeliveredIncorrectShipmentTicket();
          setCurrentFlow(DELIVERED_INCORRECT_SHIPMENT_FLOW);
          const ticketResponse = await withThinkingIndicator(
            () => createComplintTicket(getAWBValue(), getIntentTicket())
          );
          if (ticketResponse) {
            await insertMessages(ticketResponse);
          }
          await promptDeliveredStillHaveQuery();
          return;
        }
        // Pickupdone (picked): only path is "My shipment has not been picked" →
        // skip the single oval chip hub and open the agreement Yes/No directly.
        if (isPickupDoneContext()) {
          if (
            message === 'I have pickup related concern'
            || message === 'I have pickup related concerns'
          ) {
            setButtonName(message);
            setCurrentFlow('My shipment has not been picked');
            await fetchResponses('My shipment has not been picked', true);
            return;
          }
          if (message === 'My shipment has not been picked') {
            setButtonName(message);
            setCurrentFlow('My shipment has not been picked');
            await fetchResponses(message, true);
            return;
          }
        }
        // Pending-for-Pickup contact-details sub-buttons: AWB + OTP are already
        // validated, so bypass the standard re-entry flow and prompt directly
        // for the new value. Downstream handling (handleInputSubmit → update-
        // contact-number-yes / update-contact-address-yes) is unchanged.
        // Uses startPickup* helpers so intent + addressUpdateStep are set
        // (plain setCurrentFlow alone would break pincode routing).
        {
          const latestStatus = String(
            shipmentPddData.current.latestStatus || getLatestShipmentStatus() || ''
          ).trim().toLowerCase();
          if (latestStatus === 'pending_for_pickup') {
            if (message === UPDATE_ALT_MOBILE_PICKUP) {
              await startPickupAltMobileFlow(message);
              return;
            }
            if (message === 'Change the address') {
              await startPickupAddressUpdateFlow(message);
              return;
            }
            // Pending-for-Pickup cancel: pin currentFlow so the subsequent
            // Yes/No click reliably enters the pickup-specific branches
            // (YES → createCancelTicket → RVP subReasonId=300) and
            // (NO → "No changes made" — prevents falling through
            // to the UPDATE_CONTACT_ADDRESS handler which fires the wrong
            // "address remains unchanged" message when the user had also
            // clicked "Change the address" earlier in the session).
            if (message === 'I want to cancel my pickup') {
              setButtonName(message);
              setCurrentFlow('I want to cancel my pickup');
              await fetchResponses(message, true);
              return;
            }
          }
        }
        if (
          isNprShipmentRelatedConcernButton(message)
          && (isReverseNprUserContext() || isPendingPickupContext())
        ) {
          setButtonName(message);
          setCurrentFlow(NPR_SHIPMENT_CONCERNS_MONGO_TYPE);
          setNprConcernsActive(true);
          await fetchResponses(message, true);
          return;
        }
        if (isReversePickupHubContext()) {
          if (isUpdateContactDetailsButton(message) && isPendingPickupContext()) {
            setButtonName(message);
            await fetchResponses(message.replace(/\.$/, ''), false);
            return;
          }
          // Pending (npr_pickup_not_done) + reverse NPR (incl. refund/replacement-first):
          // same pincode → address / alt-mobile helpers as pending_for_pickup above.
          if (isPickupAddressUpdateButton(message)) {
            await startPickupAddressUpdateFlow(message);
            return;
          }
          if (isPickupAltMobileButton(message)) {
            await startPickupAltMobileFlow(message);
            return;
          }
          // NPR hub (pickup-not-done + remapped npr): call existing backend
          // update_pickup_date / cancel-pickup flows via fetch-records.
          if (isReschedulePickupButton(message)) {
            setButtonName(RESCHEDULE_PICKUP);
            setCurrentFlow(RESCHEDULE_PICKUP);
            setIntentName('update-pickup-date');
            setIntentTicket('update-pickup-date-yes');
            await fetchResponses(RESCHEDULE_PICKUP, true);
            return;
          }
          if (message === 'I want to cancel my pickup') {
            // Pin currentFlow so Yes/No enter pickup-specific branches
            // (YES → createCancelTicket, NO → "No changes made") and do not
            // fall through to UPDATE_CONTACT_ADDRESS messaging.
            setButtonName(message);
            setCurrentFlow('I want to cancel my pickup');
            await fetchResponses(message, true);
            return;
          }
          // NPR pickup-not-done hub: client special flows first; OFP/CNA and
          // generic pending pickup delegate to npr_pickup_not_done_flow via fetch-records.
          if (isNdrSpecialFlowTrigger(message)) {
            const nprSnapshot = getNprShipmentSnapshot();
            if (
              nprSnapshot
              && String(nprSnapshot.businessType || '').toLowerCase() === 'reverse'
              && isNprSpecialFlowLatestStatus(nprSnapshot)
            ) {
              setButtonName(message);
              const nprFlowResponse = await routeReverseNprSpecialFlows(nprSnapshot);
              if (nprFlowResponse) {
                insertMessages(nprFlowResponse);
                await applyPostOrderStatusFlowEffects(nprFlowResponse, getAWBValue());
                return;
              }
            }
            setButtonName(message);
            setCurrentFlow(NPR_PICKUP_WHERE_IS_LABEL);
            await delegateNprPickupFetchRecords(NPR_PICKUP_WHERE_IS_LABEL);
            return;
          }
        }
        if (isUpdateContactDetailsButton(message)) {
          const isNdrContactContext = isForwardNdrUserContext()
            || isNdrEnquirySessionFlow()
            || (
              String(getLatestShipmentStatus() || '').toLowerCase() === 'ndr'
              && Boolean(getAWBValue())
              && getIsOTPValidated() === 'true'
            );
          if (isNdrContactContext && !isPendingPickupContext()) {
            setButtonName(message);
            const contactMenu = await withThinkingIndicator(() => fetchUpdateContactDetailsMenuOptions());
            insertMessages(contactMenu);
            return;
          }
        }
        // Rider concerns menu must run before the generic fetchResponses fall-through.
        if (isRiderConcernsMenuButton(message)) {
          await openRiderConcernsMenu(message);
          return;
        }
        if (isRiderConcernButton(message)) {
          await startRiderConcernFlow(message);
          return;
        }
        const ndrEnquiryResponse = await handleNdrEnquiryButtonClick(message);
        if (ndrEnquiryResponse !== null) {
          insertMessages(ndrEnquiryResponse);
          await applyPostOrderStatusFlowEffects(ndrEnquiryResponse, getAWBValue());
          return;
        }
        const ndrSnapshot = getNdrShipmentSnapshot();
        const isForwardNdrSnapshot = Boolean(
          ndrSnapshot
          && String(ndrSnapshot.businessType || '').toLowerCase() === 'forward'
          && String(ndrSnapshot.latestStatus || '').toLowerCase() === 'ndr'
        );
        if (isWhereShipment && isForwardNdrSnapshot) {
          const forcedNdrFlowResponse = await routeForwardNdrSpecialFlows(ndrSnapshot);
          insertMessages(forcedNdrFlowResponse);
          await applyPostOrderStatusFlowEffects(forcedNdrFlowResponse, getAWBValue());
          return;
        }
        const nprSnapshot = getNprShipmentSnapshot();
        const isReverseNprSnapshot = Boolean(
          nprSnapshot
          && String(nprSnapshot.businessType || '').toLowerCase() === 'reverse'
          && isNprSpecialFlowLatestStatus(nprSnapshot)
        );
        if (isWhereShipment && isReverseNprSnapshot) {
          const forcedNprFlowResponse = await routeReverseNprSpecialFlows(nprSnapshot);
          if (forcedNprFlowResponse) {
            insertMessages(forcedNprFlowResponse);
            await applyPostOrderStatusFlowEffects(forcedNprFlowResponse, getAWBValue());
            return;
          }
          setButtonName(message);
          setCurrentFlow(NPR_PICKUP_WHERE_IS_LABEL);
          await delegateNprPickupFetchRecords(NPR_PICKUP_WHERE_IS_LABEL);
          return;
        }
        if (isNdrEnquirySessionFlow()) {
          if (isNdrShipmentConcernsButton(message)) {
            setNdrConcernsActive(true);
            setButtonName(message);
            const concernsMenu = await withThinkingIndicator(() => fetchNdrShipmentConcernsMenuOptions());
            insertMessages(concernsMenu);
            return;
          }
          prepareNdrContactDetailsChildFlow(message);
          const concernsPrep = prepareNdrShipmentConcernsChildFlow(message);
          setButtonName(message);
          if (concernsPrep?.awaitingCancelConfirm) {
            setAwaitingCancelConfirm(true);
          }
          if (concernsPrep?.appendDeliveryDates) {
            setButtonName(concernsPrep.selfCollect ? SELF_COLLECT_SHIPMENT : RESCHEDULE_SHIPMENT);
            await fetchResponses(concernsPrep.fetchType, true);
            return;
          }
          const fetchType = concernsPrep?.fetchType || message;
          await fetchResponses(fetchType, false);
          return;
        }
        if (isNdrShipmentConcernsButton(message) && getAWBValue()) {
          const latestStatusForConcerns = String(
            shipmentPddData.current.latestStatus || getLatestShipmentStatus() || ''
          ).trim().toLowerCase();
          // lm_facility / non-NDR: skip NDR hydrate (UF + customer-mobile) which caused
          // a long gap before the thinking loader, and open the concerns menu directly.
          if (latestStatusForConcerns === 'lm_facility') {
            setButtonName(message);
            setCurrentFlow(resolveShipmentConcernsMongoType());
            await fetchResponses(resolveShipmentConcernsMongoType(), true);
            return;
          }
          if (latestStatusForConcerns === 'ndr' && getIsOTPValidated() === 'true') {
            await withThinkingIndicator(() => hydrateForwardNdrShipmentContext(getAWBValue()));
          }
          if (isForwardNdrUserContext() || latestStatusForConcerns === 'ndr') {
            setNdrConcernsActive(true);
            setButtonName(message);
            const concernsMenu = await withThinkingIndicator(() => fetchNdrShipmentConcernsMenuOptions());
            insertMessages(concernsMenu);
            return;
          }
          if (isReverseNprUserContext()) {
            setNprConcernsActive(true);
            setButtonName(message);
            const concernsMenu = await withThinkingIndicator(() => fetchNprShipmentConcernsMenuOptions());
            insertMessages(concernsMenu);
            return;
          }
        }
        if (isNdrCancelShipmentButton(message)) {
          setAwaitingCancelConfirm(true);
          setCurrentFlow(CANCEL_ORDER);
        }
        if (isNdrRescheduleShipmentButton(message)) {
          setButtonName(RESCHEDULE_SHIPMENT);
          setCurrentFlow(RESCHEDULE_SHIPMENT);
          setIntentName('update-delivery-date');
          setIntentTicket('update-delivery-date-yes');
        }
        if (isNdrSelfCollectShipmentButton(message)) {
          setButtonName(SELF_COLLECT_SHIPMENT);
          setCurrentFlow(SELF_COLLECT_SHIPMENT);
          setIntentName('update-selfCollect-date');
          setIntentTicket('update-selfCollect-date-yes');
          setIntentValue('26');
        }
        if (
          message === UPDATE_CONTACT_ADDRESS
          && !isPendingPickupContext()
          && !isNdrEnquirySessionFlow()
        ) {
          prepareNdrContactDetailsChildFlow(message);
          setAllowFreeTextInput(true);
          handlePlaceholderChange('Please enter the 6-digit pincode to check serviceability.');
          console.log('[handleButtonClick] Set current flow to:', UPDATE_CONTACT_ADDRESS);
        }
        if (isPickupAltMobileButton(message)) {
          // Entering the alternate-mobile flow — drop any stale address-update
          // state so typed input is validated as a mobile number, not a pincode.
          setAddressUpdateStep('');
          clearAltMobileOtpState();
        }
        if (isNdrSpecialFlowTrigger(message) && !getNdrShipmentSnapshot()) {
          const nprSnapshot = getNprShipmentSnapshot();
          if (
            nprSnapshot
            && String(nprSnapshot.businessType || '').toLowerCase() === 'reverse'
            && isNprSpecialFlowLatestStatus(nprSnapshot)
          ) {
            setButtonName(message);
            const nprFlowResponse = await routeReverseNprSpecialFlows(nprSnapshot);
            if (nprFlowResponse) {
              insertMessages(nprFlowResponse);
              await applyPostOrderStatusFlowEffects(nprFlowResponse, getAWBValue());
              return;
            }
            await fetchResponses(message, true);
            return;
          }
          if (isReversePickupHubContext()) {
            setButtonName(message);
            setCurrentFlow(NPR_PICKUP_WHERE_IS_LABEL);
            await delegateNprPickupFetchRecords(NPR_PICKUP_WHERE_IS_LABEL);
            return;
          }
          const latestStatus = shipmentPddData.current.latestStatus || getLatestShipmentStatus();
          if (latestStatus === 'rto') {
            // RTO flow — backend handles diamond validation via fetch-records
            fetchResponses(message, true);
            return;
          }
          const msg = await withThinkingIndicator(
            () => getWhereIsMyShipmentMessage(shipmentPddData.current.pddBreach, shipmentPddData.current.pdd)
          );
          insertMessages(msg);
          // clearSelectedKeys(clearSessionKeys);
          fetchResponses(additionalOptions, false);
          return;
        }
        let fetchType = message;
        let fetchFlag = true;
        if (isNdrCancelShipmentButton(message)) {
          fetchType = resolveCancelShipmentMongoType();
          fetchFlag = false;
        } else if (isNdrRescheduleShipmentButton(message)) {
          fetchType = resolveRescheduleShipmentMongoType();
          fetchFlag = true;
        } else if (isNdrSelfCollectShipmentButton(message)) {
          fetchType = resolveSelfCollectShipmentMongoType();
          fetchFlag = true;
        } else if (isRenamedShipmentConcernsButton(message)) {
          fetchType = resolveShipmentConcernsMongoType();
          fetchFlag = true;
        }
        fetchResponses(fetchType, fetchFlag);
      }
    } catch (error) {
      console.log('Error handling button click:', error)
    }
  }

  const handleHomeButtonClick = async () => {
    if (homeButtonDisabled) return;
    if (homeClickInFlightRef.current) return;
    if (Date.now() - lastHomeClickAtRef.current < 5000) return;
    homeClickInFlightRef.current = true;
    lastHomeClickAtRef.current = Date.now();
    try {
      if (altMobileOtpRedirectTimerRef.current) {
        clearTimeout(altMobileOtpRedirectTimerRef.current);
        altMobileOtpRedirectTimerRef.current = null;
      }
      resetAltNumRetry();
      clearAltMobileOtpState();

      const latestStatus = shipmentPddData.current.latestStatus || getLatestShipmentStatus();
      const awb = shipmentPddData.current.awb || getAWBValue();

      // OTP pending, or OTP done but no shipment chosen yet (multi-AWB list) —
      // full welcome reset so AWB/mobile entry works again.
      if (getIsOTPValidated() !== 'true' || !latestStatus) {
        clearSessionStorage();
        shipmentPddData.current = { pddBreach: null, pdd: '', latestStatus: '', awb: '' };
        sessionMeta.current = { shippingIds: [], mobile_number: '' };
        setRiderConcernsActive(false);
        setNprConcernsActive(false);
        setNdrConcernsActive(false);
        setAdiPostAddressPending(false);
        setPncReschedulePending(false);
        setAddressUpdateStep('');
        setAwaitingCancelConfirm(false);
        setButtonName('');
        setCurrentFlow('');
        setBotAwaitingSelection(false);
        setSelectedMessages((prevMessages) => (
          prevMessages.filter((msg) => msg.isType !== 'button' && msg.isType !== 'date' && msg.isType !== 'calendar')
        ));
        setIntentValue('');
        fetchHomeButtons();
        setAllowFreeTextInput(false);
        handlePlaceholderChange(validInputPrompt);
        setHomeIcon(false);
        return;
      }

      setRiderConcernsActive(false);
      setNprConcernsActive(false);
      setNdrConcernsActive(false);
      setAdiPostAddressPending(false);
      setPncReschedulePending(false);
      setAddressUpdateStep('');
      setButtonName('');
      setCurrentFlow('');
      setSelectedMessages((prevMessages) => (
        prevMessages
          .filter((msg) => msg.isType !== 'button' && msg.isType !== 'date' && msg.isType !== 'calendar')
          .map((msg) => (msg?.inlineChoices ? { ...msg, inlineChoices: undefined } : msg))
      ));

      // "Yes please" must keep session — restore AWB/snapshot if address-update paths cleared only UI step
      if (awb && !getAWBValue()) {
        setAWBValue(awb);
      }
      if (latestStatus && !getLatestShipmentStatus()) {
        setLatestShipmentStatus(latestStatus);
      }
      if (awb && getIsOTPValidated() === 'true' && !getNdrShipmentSnapshot() && String(latestStatus || '').toLowerCase() === 'ndr') {
        await hydrateForwardNdrShipmentContext(awb);
      }

      if (latestStatus) {
        const payload = await createShowStatusButtonsPayload(latestStatus, awb);
        const response = await fetch(config.chatbotbackendapi, await fetchHeaders(payload));
        if (response.ok) {
          const result = await response.json();
          if (result && Array.isArray(result.response) && result.response.length > 0) {
            setIntentValue('');
            await insertMessages(result.response);
            handlePlaceholderChange(quickResponsePrompt);
            setHomeIcon(true);
            return;
          }
        }
        setIntentValue('');
        await fetchResponses(additionalOptions, false);
        handlePlaceholderChange(quickResponsePrompt);
        setHomeIcon(true);
        return;
      }

      // No active session — show the initial home buttons
      setIntentValue('');
      fetchHomeButtons();
      setAllowFreeTextInput(false);
      handlePlaceholderChange(validInputPrompt);
      setHomeIcon(false);
    } catch (error) {
      console.log('Error handling home button click:', error);
    } finally {
      homeClickInFlightRef.current = false;
    }
  };

  const handlePlaceholderChange = (msg) => {
    setPlaceholder(msg);
  };

  const resolveOptionText = (option) => (
    option?.content ?? option?.context ?? option?.key ?? option?.text ?? ''
  );

  const mapInlineChoice = (option) => ({
    text: resolveOptionText(option),
    isType: option?.type || 'button',
  });

  const normalizeResponseItems = (response) => {
    if (!Array.isArray(response)) {
      return response;
    }
    const normalized = [];
    let index = 0;
    while (index < response.length) {
      const item = response[index];
      if (item?.type === 'buttons' && Array.isArray(item.buttons)) {
        const textItems = item.buttons.filter((btn) => btn && (btn.type || 'button') === 'text');
        const choiceItems = item.buttons.filter((btn) => btn && (btn.type || 'button') !== 'text');
        if (textItems.length && choiceItems.length) {
          normalized.push({
            type: 'menu',
            text: textItems.map((btn) => resolveOptionText(btn)).filter(Boolean).join('\n'),
            choices: choiceItems,
          });
          index += 1;
          continue;
        }
        normalized.push(item);
        index += 1;
        continue;
      }
      const itemText = resolveOptionText(item);
      if (item?.type === 'text' && itemText) {
        const choices = [];
        let nextIndex = index + 1;
        while (nextIndex < response.length) {
          const nextItem = response[nextIndex];
          if (nextItem?.type === 'button' || nextItem?.type === 'date') {
            choices.push(nextItem);
            nextIndex += 1;
          } else {
            break;
          }
        }
        if (choices.length) {
          normalized.push({ type: 'menu', text: itemText, choices });
          index = nextIndex;
          continue;
        }
      }
      normalized.push(item);
      index += 1;
    }
    return normalized;
  };

  const insertMessages = async (response) => {
    try {
      hideThinkingIndicator();
      let lastType = null;
      if (Array.isArray(response)) {
        const items = normalizeResponseItems(response);
        if (items && items.length > 0) {
          const shipmentButtons = items.filter(obj => obj && !obj.lastMsg && obj.type === 'button' && obj.content && /Shipment ID\s*:/.test(obj.content));
          const isMultiShipment = shipmentButtons.length > 1;

          for (let obj of items) {
            if (obj && obj.lastMsg) {
              fetchResponses(additionalOptions, false);
              continue;
            }

            if (obj.type === 'menu') {
              const menuText = String(obj.text || '').trim();
              const menuChoices = (obj.choices || []).map(mapInlineChoice);
              setSelectedMessages((prevMessages) => {
                const isHelpMenuPrompt = /how can we help you|what would you like to check/i.test(menuText);
                const alreadyHasPrompt = Boolean(menuText) && isHelpMenuPrompt && prevMessages.some((message) => (
                  message?.type === 'server'
                  && String(message.text || '').trim().toLowerCase() === menuText.toLowerCase()
                ));
                if (alreadyHasPrompt) {
                  if (!menuChoices.length) {
                    return prevMessages;
                  }
                  return [
                    ...prevMessages.map((message) => (
                      message?.type === 'server'
                      && String(message.text || '').trim().toLowerCase() === menuText.toLowerCase()
                        ? { ...message, inlineChoices: undefined }
                        : message
                    )),
                    ...menuChoices.map((choice) => ({
                      type: 'server',
                      text: choice.text,
                      isType: choice.isType || 'button',
                      timestamp: returnTime(),
                    })),
                  ];
                }
                return [...prevMessages, {
                  type: 'server',
                  text: menuText,
                  isType: 'text',
                  inlineChoices: menuChoices,
                  timestamp: returnTime(),
                }];
              });
              if (menuText) {
                logMessage('chatBot', menuText);
              }
              lastType = 'button';
              continue;
            }

            if (obj.type === 'calendar') {
              setSelectedMessages((prevMessages) => [...prevMessages, {
                type: 'server',
                text: '',
                isType: 'calendar',
                calendarActive: obj.calendarActive ?? true,
                calendarLocked: obj.calendarLocked ?? false,
                timestamp: returnTime(),
              }]);
              lastType = 'calendar';
              continue;
            }

            // Handle buttons container object
            if (obj.type === 'buttons' && obj.buttons && Array.isArray(obj.buttons)) {
              obj.buttons.forEach(button => {
                if (!button) return;
                const btnText = (button.content != null ? button.content : (button.text != null ? button.text : ''));
                setSelectedMessages((prevMessages) => [...prevMessages, { type: 'server', text: String(btnText), isType: button.type || 'button', timestamp: returnTime() }]);
                logMessage('chatBot', String(btnText));
              });
              const hasSelectableOption = obj.buttons.some(
                button => button && (button.type || 'button') !== 'text'
              );
              lastType = hasSelectableOption ? 'button' : 'text';
              continue;
            }

            // render to UI always
            // Handle both 'content' and 'text' fields for backward compatibility
            const messageText = obj.content != null ? obj.content : (obj.text != null ? obj.text : '');
            setSelectedMessages((prevMessages) => [...prevMessages, { type: 'server', text: String(messageText), isType: obj.type, timestamp: returnTime() }]);
            lastType = obj.type;

            if (isMultiShipment && obj.type === 'button' && /Shipment ID\s*:/.test(obj.content)) {
              // skip — will be logged as one grouped entry below
              continue;
            }
            logMessage('chatBot', messageText);
          }

          // log all shipment buttons as a single grouped message
          if (isMultiShipment) {
            const shipments = shipmentButtons.map(obj => {
              const idMatch = obj.content.match(/Shipment ID\s*:\s*(\S+)/);
              const statusMatch = obj.content.match(/Status\s*:\s*(\S+)/);
              return {
                shippingId: idMatch ? idMatch[1] : obj.content.trim(),
                status: statusMatch ? statusMatch[1].trim() : '',
              };
            });
            conversationLog.current.push({
              sender: 'chatBot',
              message: 'Multiple shipments found',
              shipments,
              timestamp: new Date().toISOString(),
            });
          }
        }
      } else if (response) {
        setSelectedMessages((prevMessages) => [...prevMessages, { type: 'server', text: response, isType: 'text', timestamp: returnTime() }]);
        logMessage('chatBot', response);
        lastType = 'text';
      }
      if (lastType === 'button' || lastType === 'date' || lastType === 'calendar') {
        setBotAwaitingSelection(true);
        handlePlaceholderChange(quickResponsePrompt);
      } else if (lastType === 'text') {
        setBotAwaitingSelection(false);
        handlePlaceholderChange(validInputPrompt);
      }
    } catch (error) {
      console.log('Error inserting messages:', error);
    }
  }

  const fetchResponsesInternal = async (input, flag) => {
    try {
      if (isAssistYesButton(input)) {
        // Clear intent-value when user clicks "Yes please."
        setIntentValue('');
        handleHomeButtonClick();
        return;
      }
      let response = await fetchOptionsOfInput(input, flag);
      if (input === CANCEL_ORDER || input === resolveCancelShipmentMongoType()) {
        response = await fetchCancelShipmentConfirmationOptions();
      }
      // #features_pxb5559 changes done for future pickup
      if ((getButtonName() === `${FUTURE_DATE_DELIVERY} - YES` || getButtonName() === `${FUTURE_PICKUP_DATE} - YES`) && flag) {
        response = await getFutureDeliveryDates(response);
      }
      // lm_facility reschedule flow — show +1, +2, and +3 date options
      if ((getButtonName() === RESCHEDULE_SHIPMENT || getButtonName() === `${RESCHEDULE_SHIPMENT} - YES`) && flag) {
        response = await getFutureDeliveryDates(response);
      }
      // Self-collect flow — show date picker (+1, +2, and +3 days)
      if ((getButtonName() === SELF_COLLECT
        || getButtonName() === SELF_COLLECT_SHIPMENT
        || getButtonName() === `${SELF_COLLECT} - YES`
        || getButtonName() === `${SELF_COLLECT_SHIPMENT} - YES`) && flag) {
        response = await getFutureDeliveryDates(response);
      }
      // Reverse-pickup reschedule flow (pending-for-pickup AND NPR
      // "Pickup Not Done") — the backend delegates to the existing
      // update_pickup_date handler (which does NOT append date options
      // — those are rendered client-side via getFutureDeliveryDates,
      // same as the forward RESCHEDULE_SHIPMENT / FUTURE_PICKUP_DATE flows).
      // The button label here is bespoke (RESCHEDULE_PICKUP) and matches
      // neither RESCHEDULE_SHIPMENT nor FUTURE_PICKUP_DATE, so we gate on
      // the reverse-pickup statuses to avoid accidentally matching the
      // string in unrelated flows.
      if (getButtonName() === RESCHEDULE_PICKUP && flag) {
        if (isReversePickupHubContext()) {
          response = await getFutureDeliveryDates(response);
        }
      }
      await insertMessages(response);
      if (isAssistYesButton(input) || isAssistNoButton(input)) {
        // Session data preserved for feedback/conversation tracking
        setIntentValue('');
      }
      // "No, Thanks!" — show feedback question before ending chat
      if (isAssistNoButton(input)) {
        // Fetch feedback options from Redis via backend
        const feedbackResponse = await fetchFeedbackOptions();
        if (feedbackResponse && feedbackResponse.length > 0) {
          await insertMessages(feedbackResponse);
        }
        setAwaitingFeedback(true);
        handlePlaceholderChange(quickResponsePrompt);
      }
    } catch (error) {
      console.log('Error fetching responses:', error);
    }
  };

  const fetchResponses = (input, flag) => (
    withThinkingIndicator(() => fetchResponsesInternal(input, flag))
  );

  const startShipmentOtpFlow = async (shippingId) => (
    withThinkingIndicator(async () => {
      setAWBValue(shippingId);
      sessionMeta.current.shippingId = shippingId;
      const registeredNo = await validateShippingID(shippingId);
      // Success = non-empty string (plain 10-digit or enc_v1:...). Objects are errors.
      if (typeof registeredNo === 'string' && registeredNo.trim()) {
        // continue to OTP prompt below
      } else if (registeredNo?.error === 'auth') {
        insertMessages('We are unable to connect right now. Please try again in a moment.');
        return false;
      } else if (registeredNo?.message) {
        // Backend outage / NO_ORDERS / invalid AWB copy — show as returned.
        insertMessages(registeredNo.message);
        return false;
      } else {
        insertMessages(constants.INVALID_AWB_MESSAGE);
        return false;
      }
      // OTP is sent server-side during fetch-mobile-no (shipment_details → SEND_SMS)
      setIsOtpSent(true);
      await fetchResponsesInternal(otpKey, false);
      return false;
    })
  );

  const fetchShipmentDetails = async (shippingId) => {
    try {
      if (getIsOTPValidated() !== 'true') {
        await startShipmentOtpFlow(shippingId);
        return;
      }
      const response = await withThinkingIndicator(() => fetchIntentOfInput(shippingId, true));
      // Capture PDD data into memory ref before any clearSelectedKeys wipes session storage
      shipmentPddData.current = { pddBreach: getPddBreach(), pdd: getEDD() };
      insertMessages(response);
      if (!Array.isArray(response) && String(response).toLowerCase().includes('enter your pincode below')) {
        setAddressUpdateStep('pincode');
      }
      const currentFlow = getCurrentFlow();
      if (!Array.isArray(response) && response && response.includes("Sorry!")) {
        if (shouldPromptAdditionalOptionsAfterStatus()) {
          fetchResponses(additionalOptions, false);
        }
      } else if (currentFlow === FUTURE_DATE_DELIVERY || currentFlow === FUTURE_PICKUP_DATE) {
        fetchResponses(`${currentFlow} - confirmation`, true)
      } else if (!Array.isArray(response) && response && response.includes('is not a')) {
        createTicket(shippingId)
        if (shouldPromptAdditionalOptionsAfterStatus()) {
          fetchResponses(additionalOptions, false);
        }
      } else if (getIntentTicket().includes('complaint')) {
        if (isNdrReattemptComplaintFlow(currentFlow)) {
          createComplaintTicket(shippingId);
        } else {
          fetchResponses(complaintConfirmation, false);
        }
      } else if (currentFlow.includes('alternate')) {
        if (response && response.length > 0) {
          if (getNumber()) {
            fetchResponses(`${currentFlow} - confirmation`, true)
          } else {
            fetchResponses(`${currentFlow} - shipment`, false);
          }
        }
      } else if (isNdrReattemptComplaintFlow(currentFlow)) {
        createComplaintTicket(shippingId);
      } else if (await tryHandleWhereIsMyShipmentSpecialFlow()) {
        return;
      } else if (getIntentName().includes("order-status")) {
        if (isOrderStatusClosedTicketFlow(currentFlow)) {
          createTicket(shippingId);
        } else if (!isAddressUpdateFlow() && !isNdrAuthenticFlow() && !isRefundReplacementNoAutoTicketFlow(currentFlow) && !isEnquirySessionFlow(currentFlow) && !Array.isArray(response)) {
          createTicket(shippingId);
          if (!isNprHandedPostTicketFlow(currentFlow)) {
            fetchResponses(additionalOptions, false);
          }
        }
      } else if (getButtonName() === WHERE_IS_MY_SHIPMENT) {
        const msg = await withThinkingIndicator(
          () => getWhereIsMyShipmentMessage(shipmentPddData.current.pddBreach, shipmentPddData.current.pdd)
        );
        insertMessages(msg);
        // clearSelectedKeys(clearSessionKeys);
        fetchResponses(additionalOptions, false);
      } else if (shouldPromptAdditionalOptionsAfterStatus()) {
        fetchResponses(additionalOptions, false);
      }
    } catch (error) {
      console.log('Error fetching shipment details:', error);
    }
  }

  const createTicket = async (shipmentId) => {
    try {
      if (getCurrentFlow() === NPR_CWFP_REATTEMPT && sessionStorage.getItem('cwfp-reattempt-ticket-created') === 'true') {
        return;
      }
      if (!shipmentId)
        shipmentId = getAWBValue();
      // Never clear OTP/login session when there is no selected AWB yet
      // (e.g. multi-shipment picker after mobile OTP).
      if (!shipmentId) {
        return;
      }
      const ticket = await createStatusTicket(shipmentId, getIntentTicket());
      if (!isNprHandedSessionFlow()) {
        clearSelectedKeys(clearSessionKeys);
      }
    } catch (error) {
      console.log('Error creating ticket:', error);
    }
  }

  const createUpdatTicket = async (updatedValue) => {
    try {
      // Derive the correct ticket intent name from the current flow
      // to avoid relying on a potentially stale getIntentTicket() value
      const currentFlow = getCurrentFlow();
      const buttonName = getButtonName();
      let ticket = getIntentTicket();
      if (currentFlow === FUTURE_DATE_DELIVERY || currentFlow === RESCHEDULE_SHIPMENT || currentFlow === NDR_PNC_DATE_SELECTION) {
        ticket = 'update-delivery-date-yes';
      } else if (currentFlow === SELF_COLLECT || currentFlow === SELF_COLLECT_SHIPMENT) {
        ticket = 'update-selfCollect-date-yes';
      } else if (currentFlow === FUTURE_PICKUP_DATE) {
        ticket = 'update-pickup-date-yes';
      }
      else if (
        currentFlow === UPDATE_ALTERNATE_CONTACT
        || getIntentName() === 'update-contact-number'
        || (buttonName && String(buttonName).toLowerCase().includes('alternate contact'))
        || (buttonName && String(buttonName).toLowerCase().includes('alternate mobile'))
      ) {
        ticket = 'update-contact-number-yes';
        setIntentName('update-contact-number');
        setIntentTicket('update-contact-number-yes');
        setCurrentFlow(UPDATE_ALTERNATE_CONTACT);
      }
      // Pending-for-Pickup reschedule uses a bespoke button label that
      // doesn't match any of the constants above. The backend still calls
      // update_pickup_date_yes → update_pickup_date_ticket_payload (which
      // is spec-correct: ticketTypeId=3, reasonId=14, subReasonId=59,
      // action=11, status=Open), so we just need to fire the right intent.
      else if (currentFlow === RESCHEDULE_PICKUP || buttonName === RESCHEDULE_PICKUP) {
        ticket = 'update-pickup-date-yes';
      }
      // Check if buttonName contains reschedule-related keywords
      else if (buttonName && (buttonName.includes(RESCHEDULE_SHIPMENT) || buttonName.includes(FUTURE_DATE_DELIVERY))) {
        ticket = 'update-delivery-date-yes';
      } else if (buttonName && (buttonName.includes(SELF_COLLECT) || buttonName.includes(SELF_COLLECT_SHIPMENT) || buttonName.toLowerCase().includes('self collect'))) {
        ticket = 'update-selfCollect-date-yes';
      } else if (buttonName && buttonName.includes(FUTURE_PICKUP_DATE)) {
        ticket = 'update-pickup-date-yes';
      }

      const result = await withThinkingIndicator(() => createUpdateTicket(updatedValue, ticket));
      // clearSelectedKeys(clearSessionKeys);
      if (Array.isArray(result) && result.length != 0) {
        insertMessages(result);
      } else if (Array.isArray(result) && result.length == 0) {
        fetchResponses(additionalOptions, false);
      } else {
        insertMessages(result);
        fetchResponses(additionalOptions, false);
      }
    } catch (error) {
      console.error('Error creating update ticket:', error);
    }
  }

  const createComplaintTicket = async () => {
    try {
      let shipmentId = getAWBValue();
      const ticket = await withThinkingIndicator(
        () => createComplintTicket(shipmentId, getIntentTicket())
      );
      // clearSelectedKeys(clearSessionKeys);
      if (Array.isArray(ticket) && ticket.length != 0) {
        insertMessages(ticket);
      } else if (Array.isArray(ticket) && ticket.length == 0) {
        fetchResponses(additionalOptions, false);
      } else {
        insertMessages(ticket);
        fetchResponses(additionalOptions, false);
      }
    } catch (error) {
      console.log('Error creating complaint ticket:', error);
    }
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleInputSubmit();
      handlePlaceholderChange('');
      setHomeIcon(true);
    }
  };

  const createCancelTicket = async () => {
    try {
      const awb = getAWBValue();
      const ticketData = await withThinkingIndicator(async () => {
        const ticketPayload = await createTicketPayload(awb, 'cancel-order-yes', 'cancel-order', awb);
        const response = await fetch(config.chatbotbackendapi, await fetchHeaders(ticketPayload));
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const result = await response.json();
        return dataReceived(result);
      });
      if (ticketData) {
        insertMessages(ticketData);
      }
      fetchResponses(additionalOptions, false);
    } catch (error) {
      console.log('Error creating cancel ticket:', error);
    }
  }

  const handleCalendarSelect = async (isoDate) => {
    try {
      if (!isoDate || calendarSelectingRef.current) return;
      if (sessionStorage.getItem('ivr_calendar_date_selected') === 'true') return;

      const [year, month, day] = isoDate.split('-');
      const displayDate = `${day}-${month}-${year}`;
      const currentFlow = getCurrentFlow();
      const inCallLogDisagreeFlow = IVR_CALL_LOG_DISAGREE_FLOWS.includes(currentFlow);
      const inRiderIncidentStep = sessionStorage.getItem('rider_concern_step') === 'date';

      // Rider concern: complete ticket directly (do not route through generic button handlers).
      if (inRiderIncidentStep) {
        if (!isIvrCalendarDateSelectable(isoDate)) {
          return;
        }
        calendarSelectingRef.current = true;
        sessionStorage.setItem('ivr_calendar_date_selected', 'true');
        setSelectedMessages((prevMessages) => [
          ...prevMessages.filter((msg) => (
            msg.isType !== 'calendar'
            && msg.isType !== 'button'
            && msg.isType !== 'date'
          )),
          { type: 'user', text: displayDate, timestamp: returnTime() },
        ]);
        logMessage('user', displayDate);
        try {
          setCurrentFlow(RIDER_CONCERN_FLOW);
          await completeRiderConcern(isoDate);
        } catch (error) {
          sessionStorage.removeItem('ivr_calendar_date_selected');
          console.error('[handleCalendarSelect] rider concern failed:', error);
          await insertMessages('Sorry, we could not register your concern right now. Please try again.');
        }
        calendarSelectingRef.current = false;
        return;
      }

      if (inCallLogDisagreeFlow) {
        if (!isIvrCalendarDateSelectable(isoDate)) {
          return;
        }
        calendarSelectingRef.current = true;
        sessionStorage.setItem('ivr_calendar_date_selected', 'true');
        setSelectedMessages((prevMessages) => [
          ...prevMessages.filter((msg) => (
            msg.isType !== 'calendar'
            && msg.isType !== 'button'
            && msg.isType !== 'date'
          )),
          { type: 'user', text: displayDate, timestamp: returnTime() },
        ]);
        logMessage('user', displayDate);
        await withThinkingIndicator(() => handleButtonClick(displayDate, { skipUserEcho: true }));
        calendarSelectingRef.current = false;
        return;
      }

      setSelectedMessages((prevMessages) => [
        ...prevMessages.filter(msg => !Array.isArray(msg) && msg.isType !== 'button' && msg.isType !== 'date' && msg.isType !== 'calendar'),
        { type: 'user', text: displayDate, timestamp: returnTime() }
      ]);
      logMessage('user', displayDate);
    } catch (error) {
      calendarSelectingRef.current = false;
      console.log('Error handling calendar select:', error);
    }
  };

  const handleDateClick = async (dateString) => {
    try {
      console.log('[handleDateClick] dateString:', dateString, '| currentFlow:', getCurrentFlow(), '| buttonName:', getButtonName());
      setSelectedMessages((prevMessages) => [
        ...prevMessages
          .filter((msg) => !Array.isArray(msg) && msg.isType !== 'button' && msg.isType !== 'date' && msg.isType !== 'calendar')
          .map((msg) => (msg?.inlineChoices ? { ...msg, inlineChoices: undefined } : msg)),
        { type: 'user', text: dateString, timestamp: returnTime() }
      ]);
      logMessage('user', dateString);
      const [day, month, year] = dateString.split('-');
      const padDay = day.padStart(2, '0');
      const padMonth = month.padStart(2, '0');
      const formattedDate = `${year}-${padMonth}-${padDay}`;
      console.log('[handleDateClick] formattedDate:', formattedDate);
      const result = await createUpdatTicket(formattedDate);
      if (result) {
        await insertMessages(result);
        fetchResponses(additionalOptions, false);
      }
    } catch (error) {
      console.log('Error handling date click:', error);
    }
  }

  if (isClosed) return null;

  return (
    <>
      {!showBot && (
        <div id="widgetmsg" data-role="none">
          <div
            data-role="none"
            id="pop"
            className="widget-notification M16_42"
          >
            <div id="widgettxt" className="widgettxt">
              <div id="widgetdesc">
                Hi! I'm XBee. How may I assist you?
              </div>
            </div>
          </div>
          <div
            data-role="none"
            id="arrow"
            className="notif-arrow"
          >
            <img
              id="smallcurve"
              src={notifArrow}
              alt=""
            />
          </div>

          <div data-role="none" id="launcher" className="launcher">
            <button
              data-role="none"
              type="button"
              id="botwidget"
              className="botwidget"
              onClick={handleBot}
            >
              <span data-role="none" id="notif" className="botwidgetnotification">
                1
              </span>
              <img
                id="widgetpopimg"
                data-role="none"
                className="widgetpopimg"
                src={bconImage}
                alt="XBee chatbot"
              />
            </button>
          </div>
        </div>
      )}

      {showBot && (
        <div className="chatbot-container chatbot-container-header-blur">
          <div className={`chatbot-header${headerScrollBlurActive ? ' chatbot-header-scroll-blur' : ''}`}>
            <div className="chatbot-header-blur-layer" aria-hidden="true" />
            <div className="chatbot-header-inner">
              <button type="button" className="header-action header-close" onClick={handleClose} aria-label="Close chat">×</button>
              <div className="header-brand" aria-label="XBee">
                <XBeeMark />
                <span className="header-brand-text">XBee</span>
              </div>
              <button type="button" className="header-action header-menu" onClick={handleMinimize} aria-label="Minimize chat">⋮</button>
            </div>
          </div>
          {showPopup && (
            <div className="popup-overlay">
              <div className="popup-content">
                <p>Closing this will end the chat.</p>
                <p>Are you sure you want to exit?</p>
                <div className="popup-buttons">
                  <button onClick={handleConfirmExit} className="confirm-button">OK</button>
                  <button onClick={handleCancelExit} className="cancel-button">CANCEL</button>
                </div>
              </div>
            </div>
          )}
          <div className="chatbot-body">
          <ChatComponent
            selectedMessages={selectedMessages}
            handleButtonClick={handleButtonClick}
            handleInputSubmit={handleInputSubmit}
            showInput={showInput}
            placeholder={placeholder}
            homeIcon={homeIcon}
            homeButtonDisabled={homeButtonDisabled}
            handleHomeButtonClick={handleHomeButtonClick}
            handleKeyPress={handleKeyPress}
            setHomeIcon={setHomeIcon}
            userInput={userInput}
            setUserInput={setUserInput}
            setSelectedMessages={setSelectedMessages}
            handleDateClick={handleDateClick}
            handleCalendarSelect={handleCalendarSelect}
            currentFlow={getCurrentFlow()}
            inputDisabled={!isFreeTextExpected()}
            isIdentifierEntry={isIdentifierEntryStep()}
            isOtpEntry={isOtpEntryStep() || isAlternateMobileOtpStep()}
            isAddressPincodeEntry={isAddressPincodeStep()}
            onChatScroll={setHeaderScrollBlurActive}
          />
          </div>
        </div>
      )}
    </>
  );
};

export default Chatbot;